document.addEventListener('DOMContentLoaded', function () {

  function applyTooltips() {

    document.querySelectorAll('label.tpo_shape_radius, label.tpo_shape_square, label.tpo_shape_circle').forEach(function(label) {

      const input = label.querySelector('input');

      if (!input || !input.value) return;

      label.setAttribute('data-color-name', input.value);

    });

  }

  applyTooltips();

  const observer = new MutationObserver(function() {
    applyTooltips();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});


/* =========================================
   NAČIN POSTAVLJANJA – OPIS IZABRANE OPCIJE
   ========================================= */

document.addEventListener('DOMContentLoaded', function () {

  const descriptions = {
    'Distanceri':
      'Vidljivi su sa prednje strane, odvajaju tablu 19 mm od površine i stvaraju atraktivan 3D efekat. Paket sadrži 2 distancera.',

    'Klik distanceri':
      'Skriveni sistem montaže koji se ne vidi sa prednje strane. Tabla je odvojena 20 mm od površine, čime se stvara atraktivan 3D efekat.',

    'Deko kape':
      'Prekrivaju glave šrafova i daju uredan završni izgled. Tabla se postavlja direktno uz površinu, bez razmaka. Paket sadrži 2 deko kape.',

    'Bez rupa - lepljenje':
      'Idealno rešenje za površine na kojima bušenje nije moguće. Tabla se izrađuje bez rupa i postavlja direktnim lepljenjem Moment Fix lepkom. Paket ne sadrži lepak.'
  };

  const mountingSelector =
    '[id*="a9fd64b0-84eb-4222-a790-c337c98fbf21"]';

  let currentValue = 'Distanceri';


  function getContainer() {
    return document.querySelector(mountingSelector);
  }


  function getInitialValue(container) {

    const selectedInput =
      container.querySelector(
        'label.tpo_is_checked_swatches input[type="radio"]'
      ) ||
      container.querySelector(
        'input[type="radio"]:checked'
      );

    if (selectedInput && descriptions[selectedInput.value.trim()]) {
      return selectedInput.value.trim();
    }

    const selectedText = container.querySelector(
      '.tpo_selected_values_span'
    );

    if (selectedText) {
      const value = selectedText.textContent.trim();

      if (descriptions[value]) {
        return value;
      }
    }

    return 'Distanceri';
  }


  function createOrMoveInfoBox() {

    const container = getContainer();

    if (!container) return null;

    const swatchesWrapper = container.querySelector(
      '.tpo_option-type-image-swatches-wrapper'
    );

    if (!swatchesWrapper) return null;

    let infoBox = container.querySelector(
      '.mounting-description-box'
    );

    if (!infoBox) {
      infoBox = document.createElement('div');
      infoBox.className = 'mounting-description-box';

      infoBox.innerHTML = `
        <div class="mounting-description-icon">ⓘ</div>
        <div class="mounting-description-text"></div>
      `;
    }

    /*
      Polje uvek stoji odmah ispod četiri kartice,
      pre dodatnih conditional opcija.
    */
    if (swatchesWrapper.nextElementSibling !== infoBox) {
      swatchesWrapper.insertAdjacentElement('afterend', infoBox);
    }

    return infoBox;
  }


  function showDescription(value) {

    if (!value) return;

    const cleanValue = value.trim();

    if (!descriptions[cleanValue]) return;

    currentValue = cleanValue;

    const infoBox = createOrMoveInfoBox();

    if (!infoBox) return;

    const textElement = infoBox.querySelector(
      '.mounting-description-text'
    );

    if (textElement) {
      textElement.textContent = descriptions[cleanValue];
    }
  }


  function initializeDescription() {

    const container = getContainer();

    if (!container) return;

    currentValue = getInitialValue(container);
    showDescription(currentValue);
  }


  /*
    Reaguje odmah na prvi dodir/klik i uzima vrednost
    direktno iz kartice koju je kupac pritisnuo.
  */
  document.addEventListener('pointerdown', function (event) {

    const label = event.target.closest(
      `${mountingSelector} label.tpo_shape_square`
    );

    if (!label) return;

    const input = label.querySelector(
      'input[type="radio"]'
    );

    if (!input || !input.value) return;

    showDescription(input.value);

  }, true);


  /*
    Rezervna provera posle Easify promene.
  */
  document.addEventListener('change', function (event) {

    const input = event.target;

    if (
      !input.matches(
        `${mountingSelector} input[type="radio"]`
      )
    ) {
      return;
    }

    showDescription(input.value);

  }, true);


  /*
    Kada Conditional Logic ponovo napravi HTML,
    vraća info-polje na pravo mesto, ali zadržava
    opis poslednje kliknute opcije.
  */
  let observerScheduled = false;

  const observer = new MutationObserver(function () {

    if (observerScheduled) return;

    observerScheduled = true;

    requestAnimationFrame(function () {
      observerScheduled = false;

      const infoBox = createOrMoveInfoBox();

      if (!infoBox) return;

      const textElement = infoBox.querySelector(
        '.mounting-description-text'
      );

      if (textElement && descriptions[currentValue]) {
        textElement.textContent = descriptions[currentValue];
      }
    });

  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });


  /*
    Easify se učitava naknadno, pa pokušavamo odmah
    i još jednom nakon kratkog vremena.
  */
  initializeDescription();

  setTimeout(initializeDescription, 300);
  setTimeout(initializeDescription, 800);

});

/* =========================================
   PREVOD REQUIRED / MIN / MAX / NUMERIC PORUKA
   ========================================= */

document.addEventListener("DOMContentLoaded", function () {

  let scheduled = false;

  function translateMessages() {

    document.querySelectorAll("*").forEach(function (el) {

      /*
        Prevodimo samo završne elemente sa tekstom,
        da ne bismo menjali veliki roditeljski kontejner.
      */
      if (el.children.length > 0) return;

      const text = String(el.textContent || '')
        .replace(/\s+/g, ' ')
        .trim();

      if (!text) return;

      if (text === "This is a required field") {
        el.textContent = "Ovo polje je obavezno za porudžbinu.";
        return;
      }

      if (/^Please enter a minimum value of\s*2\.?$/i.test(text)) {
        el.textContent = "Minimalna dozvoljena dimenzija je 2 cm.";
        return;
      }

      if (/^Please enter a maximum value of\s*59\.?$/i.test(text)) {
        el.textContent = "Maksimalna dozvoljena dimenzija je 59 cm.";
        return;
      }

      if (/This input value is not numeric/i.test(text)) {
        el.textContent = "Nakon tačke unesite 0 ili 5.";
      }

    });

  }

  function scheduleTranslate() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      translateMessages();
    });
  }

  translateMessages();

  const observer = new MutationObserver(function () {
    scheduleTranslate();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

});

/* =========================================
   PISMO – IZABRANA VREDNOST DESNO
   ========================================= */

(function () {
  'use strict';

  const CONTAINER_SELECTOR =
    '.tpo-option-container, .tpo_option-container';

  let scheduled = false;

  function clean(value) {
    return String(value || '')
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getPismoContainer() {
    const containers = document.querySelectorAll(
      CONTAINER_SELECTOR
    );

    for (const container of containers) {
      const label = container.querySelector(
        '.tpo-option-label-container .form__label, ' +
        '.tpo_option-label-container .form__label'
      );

      if (label && clean(label.textContent) === 'Pismo') {
        return container;
      }
    }

    return null;
  }

  function getSelectedPismo(container) {
    if (!container) return 'Ћирилица';

    const checked = container.querySelector(
      'input[type="radio"]:checked, ' +
      'input.tpo_buttons-input:checked'
    );

    if (checked && checked.value) {
      const value = clean(checked.value);

      if (value === 'Ћирилица' || value === 'Latinica') {
        return value;
      }
    }

    const selectedLabel = container.querySelector(
      'label.tpo_is_checked_swatches'
    );

    if (selectedLabel) {
      const input = selectedLabel.querySelector('input');

      const value = clean(
        selectedLabel.getAttribute('data-color-name') ||
        (input && input.value) ||
        ''
      );

      if (value === 'Ћирилица' || value === 'Latinica') {
        return value;
      }
    }

    return 'Ћирилица';
  }

  function getOrCreateSelectedSpan(container) {
    const labelContainer = container.querySelector(
      '.tpo-option-label-container, ' +
      '.tpo_option-label-container'
    );

    if (!labelContainer) return null;

    let selectedSpan = labelContainer.querySelector(
      '.tpo_selected_values_span'
    );

    if (!selectedSpan) {
      selectedSpan = document.createElement('span');
      selectedSpan.className =
        'tpo_selected_values_span raccoon-pismo-selected-value';

      labelContainer.appendChild(selectedSpan);
    } else {
      selectedSpan.classList.add(
        'raccoon-pismo-selected-value'
      );
    }

    labelContainer.style.setProperty('display', 'flex', 'important');
    labelContainer.style.setProperty('align-items', 'center', 'important');
    labelContainer.style.setProperty('justify-content', 'space-between', 'important');
    labelContainer.style.setProperty('width', '100%', 'important');

    selectedSpan.style.setProperty('margin-left', 'auto', 'important');
    selectedSpan.style.setProperty('text-align', 'right', 'important');
    selectedSpan.style.setProperty('color', '#777777', 'important');
    selectedSpan.style.setProperty('font-weight', '600', 'important');
    selectedSpan.style.setProperty('font-size', '16px', 'important');
    selectedSpan.style.setProperty('line-height', '1.3', 'important');
    selectedSpan.style.setProperty('white-space', 'nowrap', 'important');

    return selectedSpan;
  }

  function displayPismo(forcedValue) {
    const container = getPismoContainer();

    if (!container) return;

    const selectedSpan =
      getOrCreateSelectedSpan(container);

    if (!selectedSpan) return;

    const value =
      clean(forcedValue) ||
      getSelectedPismo(container);

    if (value !== 'Ћирилица' && value !== 'Latinica') {
      return;
    }

    if (selectedSpan.textContent.trim() !== value) {
      selectedSpan.textContent = value;
    }
  }

  function pismoFromLabel(label) {
    if (!label) return '';

    const input = label.querySelector(
      'input[type="radio"], input.tpo_buttons-input'
    );

    return clean(
      label.getAttribute('data-color-name') ||
      (input && input.value) ||
      ''
    );
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      document
        .querySelectorAll('.raccoon-font-preview')
        .forEach(function (preview) {
          fitFontPreviewToCard(preview);
        });
    });
  }

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      displayPismo();
    });
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      const container = getPismoContainer();

      if (!container) return;

      const label = event.target.closest(
        '.tpo_buttons-wrapper label'
      );

      if (!label || !container.contains(label)) return;

      const value = pismoFromLabel(label);

      if (value === 'Ћирилица' || value === 'Latinica') {
        displayPismo(value);
      }

      setTimeout(scheduleUpdate, 0);
      setTimeout(scheduleUpdate, 100);
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      const container = getPismoContainer();

      if (!container || !container.contains(event.target)) {
        return;
      }

      if (
        event.target.matches(
          'input[type="radio"], input.tpo_buttons-input'
        )
      ) {
        displayPismo(event.target.value);
        setTimeout(scheduleUpdate, 0);
      }
    },
    true
  );

  const observer =
    new MutationObserver(function () {
      scheduleUpdate();
    });

  function initialize() {
    displayPismo();

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'class',
        'checked',
        'data-color-name'
      ]
    });

    setTimeout(displayPismo, 300);
    setTimeout(displayPismo, 800);
    setTimeout(displayPismo, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }

})();

/* =========================================
   AUTOMATSKO PRETVARANJE TEKSTA PREMA PISMU
   Polja: "Naziv ulice | Natpis" i "Broj"
   ========================================= */

(function () {
  'use strict';

  const CONTAINER_SELECTOR = '.tpo_option-container, .tpo-option-container';
  const TARGET_LABELS = [
    'Naslov',
    'Tekst na tabli',
    'Registarska oznaka | Tekst',
    'Ime, prezime | Naziv',
    'Prezime | Natpis',
    'Naziv ulice | Natpis',
    'Broj'
  ];
  let internalChange = false;

  function clean(value) {
    return String(value || '')
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function findContainerByLabel(labelName) {
    const containers = document.querySelectorAll(CONTAINER_SELECTOR);

    for (const container of containers) {
      const labels = container.querySelectorAll(
        '.tpo-option-label-container .form__label, ' +
        '.tpo_option-label-container .form__label, ' +
        '.form__label, label'
      );

      for (const label of labels) {
        const text = clean(label.textContent);
        if (text === labelName || text.startsWith(labelName)) {
          return container;
        }
      }
    }

    return null;
  }

  function getPismoContainer() {
    return findContainerByLabel('Pismo');
  }

  function selectedPismo() {
    const container = getPismoContainer();
    if (!container) return 'Ћирилица';

    const checked = container.querySelector(
      'input[type="radio"]:checked, input.tpo_buttons-input:checked'
    );

    if (checked) {
      const value = clean(checked.value);
      if (value === 'Ћирилица' || value === 'Latinica') return value;
    }

    const selected = container.querySelector(
      'label.tpo_is_checked_swatches, .tpo_is_checked_swatches'
    );

    if (selected) {
      const input = selected.querySelector('input');
      const value = clean(
        selected.getAttribute('data-color-name') ||
        (input && input.value) ||
        selected.textContent
      );
      if (value === 'Ћирилица' || value === 'Latinica') return value;
    }

    return 'Ћирилица';
  }

  function fieldLabel(field) {
    const container = field.closest(CONTAINER_SELECTOR);
    if (!container) return '';

    const labels = container.querySelectorAll(
      '.tpo-option-label-container .form__label, ' +
      '.tpo_option-label-container .form__label, ' +
      '.form__label, label'
    );

    for (const label of labels) {
      const text = clean(label.textContent);
      for (const target of TARGET_LABELS) {
        if (text === target || text.startsWith(target)) return target;
      }
    }

    return '';
  }

  function isTargetField(field) {
    if (!(field instanceof HTMLInputElement) &&
        !(field instanceof HTMLTextAreaElement)) return false;

    if (
      field.disabled ||
      field.dataset.raccoonInactiveTextField === '1'
    ) {
      return false;
    }

    if (field.matches('input[type="radio"], input[type="checkbox"], input[type="hidden"]')) {
      return false;
    }

    if (fieldLabel(field)) return true;

    /* Rezervno prepoznavanje ako Easify promeni HTML strukturu. */
    const placeholder = clean(field.getAttribute('placeholder'));
return placeholder === 'Unesite željeni tekst' ||
       placeholder === 'Unesite tekst na tabli' ||
       placeholder === 'Unesite registarsku oznaku ili željeni tekst' ||
       placeholder === 'Unesite ime, prezime ili naziv' ||
       placeholder === 'Unesite prezime ili natpis' ||
       placeholder === 'Unesite naziv ulice ili natpis' ||
       placeholder === 'Unesite broj';
  }

  function latinToCyrillic(text) {
    let value = String(text || '');

    const pairs = [
      [/DŽ/g, 'Џ'], [/Dž/g, 'Џ'], [/dŽ/g, 'џ'], [/dž/g, 'џ'],
      [/LJ/g, 'Љ'], [/Lj/g, 'Љ'], [/lJ/g, 'љ'], [/lj/g, 'љ'],
      [/NJ/g, 'Њ'], [/Nj/g, 'Њ'], [/nJ/g, 'њ'], [/nj/g, 'њ'],
      [/ДŽ/g, 'Џ'], [/Дž/g, 'Џ'], [/дŽ/g, 'џ'], [/дž/g, 'џ'],
      [/ЛJ/g, 'Љ'], [/Лj/g, 'Љ'], [/лJ/g, 'љ'], [/лj/g, 'љ'],
      [/НJ/g, 'Њ'], [/Нj/g, 'Њ'], [/нJ/g, 'њ'], [/нj/g, 'њ']
    ];

    pairs.forEach(function (pair) {
      value = value.replace(pair[0], pair[1]);
    });

    const map = {
      A:'А', B:'Б', C:'Ц', Č:'Ч', Ć:'Ћ', D:'Д', Đ:'Ђ', E:'Е',
      F:'Ф', G:'Г', H:'Х', I:'И', J:'Ј', K:'К', L:'Л', M:'М',
      N:'Н', O:'О', P:'П', R:'Р', S:'С', Š:'Ш', T:'Т', U:'У',
      V:'В', Z:'З', Ž:'Ж',
      a:'а', b:'б', c:'ц', č:'ч', ć:'ћ', d:'д', đ:'ђ', e:'е',
      f:'ф', g:'г', h:'х', i:'и', j:'ј', k:'к', l:'л', m:'м',
      n:'н', o:'о', p:'п', r:'р', s:'с', š:'ш', t:'т', u:'у',
      v:'в', z:'з', ž:'ж'
    };

    return Array.from(value).map(function (ch) {
      return Object.prototype.hasOwnProperty.call(map, ch) ? map[ch] : ch;
    }).join('');
  }

  function cyrillicToLatin(text) {
    const map = {
      А:'A', Б:'B', В:'V', Г:'G', Д:'D', Ђ:'Đ', Е:'E', Ж:'Ž',
      З:'Z', И:'I', Ј:'J', К:'K', Л:'L', Љ:'Lj', М:'M', Н:'N',
      Њ:'Nj', О:'O', П:'P', Р:'R', С:'S', Т:'T', Ћ:'Ć', У:'U',
      Ф:'F', Х:'H', Ц:'C', Ч:'Č', Џ:'Dž', Ш:'Š',
      а:'a', б:'b', в:'v', г:'g', д:'d', ђ:'đ', е:'e', ж:'ž',
      з:'z', и:'i', ј:'j', к:'k', л:'l', љ:'lj', м:'m', н:'n',
      њ:'nj', о:'o', п:'p', р:'r', с:'s', т:'t', ћ:'ć', у:'u',
      ф:'f', х:'h', ц:'c', ч:'č', џ:'dž', ш:'š'
    };

    return Array.from(String(text || '')).map(function (ch) {
      return Object.prototype.hasOwnProperty.call(map, ch) ? map[ch] : ch;
    }).join('');
  }

  function convertField(field, forcedPismo) {
    if (!isTargetField(field)) return;

    const pismo = forcedPismo || selectedPismo();
    const oldValue = field.value;
    const start = field.selectionStart;
    const end = field.selectionEnd;
    const newValue = pismo === 'Latinica'
      ? cyrillicToLatin(oldValue)
      : latinToCyrillic(oldValue);

    if (newValue === oldValue) return;

    internalChange = true;
    field.value = newValue;

    if (document.activeElement === field && typeof start === 'number') {
      const difference = newValue.length - oldValue.length;
      try {
        field.setSelectionRange(
          Math.max(0, start + difference),
          Math.max(0, (typeof end === 'number' ? end : start) + difference)
        );
      } catch (error) {}
    }

    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
    internalChange = false;
  }

  function convertAll(pismo) {
    document.querySelectorAll('input, textarea').forEach(function (field) {
      if (isTargetField(field)) convertField(field, pismo);
    });
  }

  document.addEventListener('input', function (event) {
    if (internalChange) return;
    if (isTargetField(event.target)) convertField(event.target);
  }, true);

  document.addEventListener('keyup', function (event) {
    if (internalChange) return;
    if (isTargetField(event.target)) convertField(event.target);
  }, true);

  document.addEventListener('paste', function (event) {
    if (!isTargetField(event.target)) return;
    setTimeout(function () { convertField(event.target); }, 0);
  }, true);

  function pismoFromClickedLabel(label) {
    if (!label) return '';
    const input = label.querySelector('input');
    return clean(
      label.getAttribute('data-color-name') ||
      (input && input.value) ||
      label.textContent
    );
  }

  document.addEventListener('pointerdown', function (event) {
    const label = event.target.closest('.tpo_buttons-wrapper label, label');
    if (!label) return;

    const container = label.closest(CONTAINER_SELECTOR);
    if (!container || container !== getPismoContainer()) return;

    const value = pismoFromClickedLabel(label);
    if (value !== 'Ћирилица' && value !== 'Latinica') return;

    requestAnimationFrame(function () { convertAll(value); });
    setTimeout(function () { convertAll(value); }, 100);
  }, true);

  document.addEventListener('change', function (event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;

    const container = input.closest(CONTAINER_SELECTOR);
    if (!container || container !== getPismoContainer()) return;

    const value = clean(input.value);
    if (value === 'Ћирилица' || value === 'Latinica') convertAll(value);
  }, true);

})();

/* =========================================
   DODATNA SLOVA – LINK I PANEL
   ========================================= */

(function () {
  'use strict';

  const CONTAINER_SELECTOR = '.tpo-option-container, .tpo_option-container';
  const WIDGET_ID = 'raccoon-special-letters';
  const STYLE_ID = 'raccoon-special-letters-style';
  let activeTextField = null;
  let scheduled = false;

const LETTERS = {
  'Ћирилица': {
    upper: ['Ђ', 'Љ', 'Њ', 'Џ', 'Ћ', 'Ж', 'Ч', 'Ш'],
    lower: ['ђ', 'љ', 'њ', 'џ', 'ћ', 'ж', 'ч', 'ш']
  },

  'Latinica': {
    upper: ['Č', 'Ć', 'Š', 'Đ', 'Ž', 'DŽ'],
    lower: ['č', 'ć', 'š', 'đ', 'ž', 'dž']
  }
};

  function clean(value) {
    return String(value || '').trim().replace(/\s+/g, ' ');
  }

  function getLabelText(container) {
    if (!container) return '';

    const label = container.querySelector(
      '.tpo-option-label-container .form__label, ' +
      '.tpo_option-label-container .form__label, ' +
      '.form__label, label'
    );

    return label ? clean(label.textContent).replace(/\s*\*$/, '') : '';
  }

  function isRegistrationTextField(field) {
    if (!(field instanceof HTMLInputElement) &&
        !(field instanceof HTMLTextAreaElement)) return false;

    const placeholder = clean(
      field.getAttribute('placeholder')
    ).toLowerCase();

    if (
      placeholder.includes('registarsku oznaku') ||
      placeholder.includes('registarska oznaka')
    ) {
      return true;
    }

    const container = field.closest(CONTAINER_SELECTOR);
    const labelText = getLabelText(container);

    return labelText === 'Registarska oznaka | Tekst' ||
           labelText.startsWith('Registarska oznaka | Tekst');
  }

  function isTitleField(field) {
    if (!(field instanceof HTMLInputElement) &&
        !(field instanceof HTMLTextAreaElement)) return false;

    const container = field.closest(CONTAINER_SELECTOR);
    const labelText = getLabelText(container);

    return labelText === 'Naslov' ||
           labelText.startsWith('Naslov');
  }

  function isBoardTextField(field) {
    if (!(field instanceof HTMLInputElement) &&
        !(field instanceof HTMLTextAreaElement)) return false;

    const placeholder = clean(
      field.getAttribute('placeholder')
    ).toLowerCase();

    if (
      placeholder.includes('željeni tekst') ||
      placeholder.includes('tekst na tabli')
    ) {
      return true;
    }

    const container = field.closest(CONTAINER_SELECTOR);
    const labelText = getLabelText(container);

    return labelText === 'Tekst na tabli' ||
           labelText.startsWith('Tekst na tabli');
  }

  function isNameField(field) {
    if (!(field instanceof HTMLInputElement) &&
        !(field instanceof HTMLTextAreaElement)) return false;

    if (
      field.disabled ||
      field.dataset.raccoonInactiveTextField === '1'
    ) {
      return false;
    }

    const placeholder = clean(
      field.getAttribute('placeholder')
    ).toLowerCase();

    if (
      placeholder.includes('ime, prezime') ||
      placeholder.includes('ime i prezime') ||
      placeholder.includes('unesite ime') ||
      placeholder.includes('prezime') ||
      placeholder.includes('natpis') ||
      placeholder.includes('naziv')
    ) {
      return true;
    }

    const container = field.closest(CONTAINER_SELECTOR);
    const labelText = getLabelText(container);

    return labelText === 'Ime, prezime | Naziv' ||
           labelText.startsWith('Ime, prezime | Naziv') ||
           labelText === 'Prezime | Natpis' ||
           labelText.startsWith('Prezime | Natpis');
  }

  function isStreetField(field) {
    if (!(field instanceof HTMLInputElement) &&
        !(field instanceof HTMLTextAreaElement)) return false;

    const placeholder = clean(field.getAttribute('placeholder')).toLowerCase();
    if (placeholder.includes('naziv ulice') || placeholder.includes('natpis')) {
      return true;
    }

    const container = field.closest(CONTAINER_SELECTOR);
    const labelText = getLabelText(container);

    return labelText === 'Naziv ulice | Natpis' ||
           labelText.startsWith('Naziv ulice | Natpis');
  }

  function isNumberField(field) {
    if (!(field instanceof HTMLInputElement) &&
        !(field instanceof HTMLTextAreaElement)) return false;

    const placeholder = clean(field.getAttribute('placeholder')).toLowerCase();
    if (placeholder === 'unesite broj' || placeholder.includes('broj')) {
      return true;
    }

    const container = field.closest(CONTAINER_SELECTOR);
    const labelText = getLabelText(container);

    return labelText === 'Broj' || labelText.startsWith('Broj');
  }

  function getTargetFields() {
    return Array.from(document.querySelectorAll('input, textarea')).filter(function (field) {
      return isRegistrationTextField(field) ||
             isTitleField(field) ||
             isBoardTextField(field) ||
             isNameField(field) ||
             isStreetField(field) ||
             isNumberField(field);
    });
  }

  function getRegistrationTextField() {
    return getTargetFields().find(isRegistrationTextField) || null;
  }

  function getTitleField() {
    return getTargetFields().find(isTitleField) || null;
  }

  function getBoardTextField() {
    return getTargetFields().find(isBoardTextField) || null;
  }

  function getNameField() {
    return getTargetFields().find(isNameField) || null;
  }

  function getStreetField() {
    return getTargetFields().find(isStreetField) || null;
  }

  function getNumberField() {
    return getTargetFields().find(isNumberField) || null;
  }

  function getPismoContainer() {
    const containers = document.querySelectorAll(CONTAINER_SELECTOR);

    for (const container of containers) {
      if (getLabelText(container) === 'Pismo') return container;
    }

    return null;
  }

  function getSelectedPismo() {
    const container = getPismoContainer();
    if (!container) return 'Ћирилица';

    const selectedLabel =
      container.querySelector('label.tpo_is_checked_swatches') ||
      container.querySelector('label:has(input[type="radio"]:checked)');

    if (selectedLabel) {
      const input = selectedLabel.querySelector('input');
      const value = clean(
        selectedLabel.getAttribute('data-color-name') ||
        (input && input.value) ||
        selectedLabel.textContent
      );

      if (value === 'Ћирилица' || value === 'Latinica') return value;
    }

    const checked = container.querySelector('input[type="radio"]:checked');
    if (checked) {
      const value = clean(checked.value);
      if (value === 'Ћирилица' || value === 'Latinica') return value;
    }

    return 'Ћирилица';
  }

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      #${WIDGET_ID} {
        width: 100%;
        grid-column: 1 / -1;
        margin: -6px 0 20px;
      }

      #${WIDGET_ID} .raccoon-special-letters__toggle {
  appearance: none;
  display: inline-block;
  padding: 0;
  margin: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: #222;
  font-family: inherit;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.25;
  letter-spacing: 0;
  text-decoration: underline;
text-decoration-color: #1fa1ae;
text-decoration-thickness: 2px;
text-underline-offset: 2px;
}

#${WIDGET_ID} .raccoon-special-letters__toggle:hover {
  color: #1fa1ae;
}

      #${WIDGET_ID} .raccoon-special-letters__panel {
        display: none;
        flex-wrap: wrap;
        gap: 9px;
        margin-top: 14px;
        padding: 13px;
        border: 1px solid rgba(0, 0, 0, 0.10);
        border-radius: 12px;
        background: #E2F5F8;
        border: 1px solid #B7E1E6;
      }

      #${WIDGET_ID}[data-open="true"] .raccoon-special-letters__panel {
        display: flex;
      }

      #${WIDGET_ID} .raccoon-special-letters__button {
        min-width: 42px;
        height: 40px;
        padding: 0 11px;
        border: 1px solid rgba(0, 0, 0, 0.14);
        border-radius: 9px;
        background: #ffffff;
        color: #1c1c1c;
        font: inherit;
        font-size: 16px;
        line-height: 1;
        cursor: pointer;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
      }

      #${WIDGET_ID} .raccoon-special-letters__button:hover,
      #${WIDGET_ID} .raccoon-special-letters__button:focus-visible {
        border-color: #1fa1ae;
        outline: 2px solid rgba(31, 161, 174, 0.18);
        outline-offset: 1px;
      }

      @media screen and (max-width: 749px) {
        #${WIDGET_ID} .raccoon-special-letters__panel {
          gap: 8px;
          padding: 12px;
        }

        #${WIDGET_ID} .raccoon-special-letters__button {
        min-width: 36px;
        height: 36px;
        padding: 0 8px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function renderLetters(widget, pismo) {
    const panel = widget.querySelector('.raccoon-special-letters__panel');
    if (!panel) return;

    const letters = LETTERS[pismo] || LETTERS['Ћирилица'];
    panel.replaceChildren();

    letters.forEach(function (letter) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'raccoon-special-letters__button';
      button.textContent = letter;
      button.setAttribute('aria-label', 'Dodaj slovo ' + letter);
      button.dataset.letter = letter;
      panel.appendChild(button);
    });

    widget.dataset.pismo = pismo;
  }function renderLetters(widget, pismo) {
  const panel = widget.querySelector('.raccoon-special-letters__panel');
  if (!panel) return;

  panel.replaceChildren();

  const group = LETTERS[pismo] || LETTERS['Ћирилица'];

  const showLowercase =
    activeTextField &&
    (
      isNumberField(activeTextField) ||
      isNameField(activeTextField) ||
      getLabelText(
        activeTextField.closest(CONTAINER_SELECTOR)
      ) === 'Prezime | Natpis'
    );

  function addLetterButton(letter) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'raccoon-special-letters__button';
    button.textContent = letter;
    button.setAttribute(
      'aria-label',
      'Dodaj slovo ' + letter
    );
    button.dataset.letter = letter;
    panel.appendChild(button);
  }

  /*
    Prvi red: sva velika slova.
  */
  group.upper.forEach(addLetterButton);

  /*
    Samo za "Broj" i "Prezime | Natpis":
    drugi red počinje OBAVEZNO ispod prvog reda,
    pa svako malo slovo stoji ispod odgovarajućeg velikog.
  */
  if (showLowercase) {
    const rowBreak = document.createElement('span');
    rowBreak.setAttribute('aria-hidden', 'true');

    rowBreak.style.setProperty(
      'flex-basis',
      '100%',
      'important'
    );

    rowBreak.style.setProperty(
      'width',
      '0',
      'important'
    );

    rowBreak.style.setProperty(
      'height',
      '0',
      'important'
    );

    rowBreak.style.setProperty(
      'padding',
      '0',
      'important'
    );

    rowBreak.style.setProperty(
      'margin',
      '-9px 0 0',
      'important'
    );

    panel.appendChild(rowBreak);

    group.lower.forEach(addLetterButton);
  }

  widget.dataset.pismo = pismo;
}

  function createWidget() {
    const widget = document.createElement('div');
    widget.id = WIDGET_ID;
    widget.dataset.open = 'false';

    widget.innerHTML = `
      <button
        type="button"
        class="raccoon-special-letters__toggle"
        aria-expanded="false"
        aria-controls="raccoon-special-letters-panel"
      >Dodaj posebna slova</button>
      <div
        id="raccoon-special-letters-panel"
        class="raccoon-special-letters__panel"
        aria-hidden="true"
      ></div>
    `;

    renderLetters(widget, getSelectedPismo());
    return widget;
  }

  function getExactContainerByLabel(labelName) {
    const containers = document.querySelectorAll(CONTAINER_SELECTOR);

    for (const container of containers) {
      const labels = container.querySelectorAll(
        '.tpo-option-label-container .form__label, ' +
        '.tpo_option-label-container .form__label, ' +
        '.form__label, label'
      );

      for (const label of labels) {
        const text = clean(label.textContent).replace(/\s*\*$/, '');

        if (text === labelName) {
          return container;
        }
      }
    }

    return null;
  }

  function placeWidget() {
    addStyles();

    const registrationTextField = getRegistrationTextField();
    const titleField = getTitleField();
    const boardTextField = getBoardTextField();
    const nameField = getNameField();
    const streetField = getStreetField();
    const numberField = getNumberField();

    /*
      Panel se prikazuje ako postoji makar jedno podržano
      polje za personalizovani tekst.
    */
    if (
      !registrationTextField &&
      !titleField &&
      !boardTextField &&
      !nameField &&
      !streetField &&
      !numberField
    ) {
      return null;
    }

    const registrationTextContainer = registrationTextField
      ? registrationTextField.closest(CONTAINER_SELECTOR)
      : null;

    const titleContainer = titleField
      ? titleField.closest(CONTAINER_SELECTOR)
      : null;

    const boardTextContainer = boardTextField
      ? boardTextField.closest(CONTAINER_SELECTOR)
      : null;

    const nameContainer = nameField
      ? nameField.closest(CONTAINER_SELECTOR)
      : null;

    const streetContainer = streetField
      ? streetField.closest(CONTAINER_SELECTOR)
      : null;

    const numberContainer = numberField
      ? numberField.closest(CONTAINER_SELECTOR)
      : null;

    /*
      Ako postoji polje "Tekst na tabli", tražimo ga po tačnom
      nazivu i link uvek postavljamo odmah ispod tog polja.
      Na ostalim proizvodima ostaje postojeći raspored.
    */
    const exactRegistrationTextContainer =
      getExactContainerByLabel('Registarska oznaka | Tekst');

    const exactBoardTextContainer =
      getExactContainerByLabel('Tekst na tabli');

    const anchorContainer =
      exactRegistrationTextContainer ||
      exactBoardTextContainer ||
      numberContainer ||
      registrationTextContainer ||
      boardTextContainer ||
      nameContainer ||
      streetContainer;

    if (!anchorContainer || !anchorContainer.parentElement) return null;

    let widget = document.getElementById(WIDGET_ID);
    if (!widget) widget = createWidget();

    /*
      Link i panel stoje odmah ispod reda sa poljima
      "Naziv ulice | Natpis" i "Broj".
    */
    if (anchorContainer.nextElementSibling !== widget) {
      anchorContainer.insertAdjacentElement('afterend', widget);
    }

    const pismo = getSelectedPismo();
    if (widget.dataset.pismo !== pismo) renderLetters(widget, pismo);

    return widget;
  }

  function insertAtCursor(field, text) {
    /*
      Ako nema polja "Naziv ulice | Natpis",
      posebno slovo se ubacuje u polje "Broj".
    */
    if (!field) {
      field =
        getRegistrationTextField() ||
        getTitleField() ||
        getBoardTextField() ||
        getNameField() ||
        getStreetField() ||
        getNumberField();
    }

    if (!field) return;

    field.focus();

    const start = typeof field.selectionStart === 'number'
      ? field.selectionStart
      : field.value.length;
    const end = typeof field.selectionEnd === 'number'
      ? field.selectionEnd
      : start;

    if (typeof field.setRangeText === 'function') {
      field.setRangeText(text, start, end, 'end');
    } else {
      field.value = field.value.slice(0, start) + text + field.value.slice(end);
    }

    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('focusin', function (event) {
    if (
      isRegistrationTextField(event.target) ||
      isTitleField(event.target) ||
      isBoardTextField(event.target) ||
      isNameField(event.target) ||
      isStreetField(event.target) ||
      isNumberField(event.target)
    ) {
      activeTextField = event.target;

      const widget = document.getElementById(WIDGET_ID);
if (widget) {
  renderLetters(widget, getSelectedPismo());
}

    }
  }, true);

  /*
    Zadržava fokus i poziciju kursora u aktivnom polju.
    Tako Easify ne može da ukloni razmak na kraju teksta
    pre nego što se ubaci posebno slovo.
  */
  document.addEventListener('pointerdown', function (event) {
    const letterButton = event.target.closest(
      '.raccoon-special-letters__button'
    );

    if (!letterButton) return;

    event.preventDefault();
  }, true);

  document.addEventListener('click', function (event) {
    const widget = event.target.closest('#' + WIDGET_ID);
    if (!widget) return;

    const toggle = event.target.closest('.raccoon-special-letters__toggle');
    if (toggle) {
      const willOpen = widget.dataset.open !== 'true';
      widget.dataset.open = String(willOpen);
      toggle.setAttribute('aria-expanded', String(willOpen));

      const panel = widget.querySelector('.raccoon-special-letters__panel');
      if (panel) panel.setAttribute('aria-hidden', String(!willOpen));
      return;
    }

    const letterButton = event.target.closest('.raccoon-special-letters__button');
    if (letterButton) {
      insertAtCursor(activeTextField, letterButton.dataset.letter || letterButton.textContent);
    }
  }, true);

  function updateForSelectedPismo(forcedValue) {
    const widget = placeWidget();
    if (!widget) return;

    const pismo = forcedValue || getSelectedPismo();
    if (pismo !== 'Ћирилица' && pismo !== 'Latinica') return;

    if (widget.dataset.pismo !== pismo) renderLetters(widget, pismo);
  }

  document.addEventListener('pointerdown', function (event) {
    const label = event.target.closest('.tpo_buttons-wrapper label, label');
    if (!label) return;

    const container = label.closest(CONTAINER_SELECTOR);
    if (!container || container !== getPismoContainer()) return;

    const input = label.querySelector('input');
    const value = clean(
      label.getAttribute('data-color-name') ||
      (input && input.value) ||
      label.textContent
    );

    if (value === 'Ћирилица' || value === 'Latinica') {
      requestAnimationFrame(function () {
        updateForSelectedPismo(value);
      });
    }
  }, true);

  const observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      updateForSelectedPismo();
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'checked', 'data-color-name']
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      updateForSelectedPismo();
      setTimeout(updateForSelectedPismo, 400);
      setTimeout(updateForSelectedPismo, 1000);
    });
  } else {
    updateForSelectedPismo();
    setTimeout(updateForSelectedPismo, 400);
    setTimeout(updateForSelectedPismo, 1000);
  }

})();


/* =========================================
   INFO TEKST ISPOD DODATNIH UPUTSTAVA
   ========================================= */

(function () {
  'use strict';

  const CONTAINER_SELECTOR =
    '.tpo-option-container, .tpo_option-container';

  const INFO_ID = 'raccoon-order-info';

  let scheduled = false;

  function clean(text) {
    return String(text || '')
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getAdditionalInstructionsContainer() {
    const containers = document.querySelectorAll(
      CONTAINER_SELECTOR
    );

    for (const container of containers) {
      const labels = container.querySelectorAll(
        '.tpo-option-label-container .form__label, ' +
        '.tpo_option-label-container .form__label, ' +
        '.form__label, label'
      );

      for (const label of labels) {
        const text = clean(label.textContent);

        if (
          text === 'Dodatna uputstva' ||
          text.startsWith('Dodatna uputstva')
        ) {
          return container;
        }
      }
    }

    return null;
  }

  function createOrMoveInfoBox() {
    const container = getAdditionalInstructionsContainer();

    if (!container || !container.parentElement) return null;

    const field = container.querySelector(
      'textarea, input[type="text"]'
    );

    if (!field) return null;

    let info = document.getElementById(INFO_ID);

    if (!info) {
      info = document.createElement('div');
      info.id = INFO_ID;
      info.className = 'mounting-description-box';

      info.innerHTML = `
        <div class="mounting-description-icon">ⓘ</div>
        <div class="mounting-description-text">
          Molimo proverite unete podatke pre potvrde porudžbine.<br>
          <strong>Nakon završene porudžbine, putem Vibera ili e-maila dobićete pripremu na potvrdu pre početka izrade.</strong>
        </div>
      `;
    }

    if (container.nextElementSibling !== info) {
      container.insertAdjacentElement('afterend', info);
    }

    info.style.setProperty('width', '100%', 'important');
    info.style.setProperty('max-width', '100%', 'important');
    info.style.setProperty('box-sizing', 'border-box', 'important');
    info.style.setProperty('grid-column', '1 / -1', 'important');
    info.style.setProperty('flex-basis', '100%', 'important');

    info.style.setProperty('position', 'relative', 'important');
    info.style.setProperty('top', '-10px', 'important');
    info.style.setProperty('margin-top', '0', 'important');
    info.style.setProperty('margin-bottom', '10px', 'important');

    return info;
  }

  function schedulePlacement() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      createOrMoveInfoBox();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        createOrMoveInfoBox();
        setTimeout(createOrMoveInfoBox, 300);
        setTimeout(createOrMoveInfoBox, 800);
      }
    );
  } else {
    createOrMoveInfoBox();
    setTimeout(createOrMoveInfoBox, 300);
    setTimeout(createOrMoveInfoBox, 800);
  }

  const observer = new MutationObserver(function () {
    schedulePlacement();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();

/* =========================================
   NESTANDARDNA DIMENZIJA – INFO TEKST
   ========================================= */

(function () {
  'use strict';

  const CONTAINER_SELECTOR =
    '.tpo-option-container, .tpo_option-container';

  const INFO_ID = 'raccoon-custom-dimension-info';
  let scheduled = false;

  function clean(text) {
    return String(text || '')
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getContainerByLabel(labelName) {
    const containers = document.querySelectorAll(CONTAINER_SELECTOR);

    for (const container of containers) {
      const labels = container.querySelectorAll(
        '.tpo-option-label-container .form__label, ' +
        '.tpo_option-label-container .form__label, ' +
        '.form__label, label'
      );

      for (const label of labels) {
        const text = clean(label.textContent);

        if (text === labelName || text.startsWith(labelName)) {
          return container;
        }
      }
    }

    return null;
  }

  function createOrMoveInfoBox() {
    const widthContainer = getContainerByLabel('Širina (cm)');
    const heightContainer = getContainerByLabel('Visina (cm)');

    if (!widthContainer || !heightContainer) return null;
    if (!heightContainer.parentElement) return null;

    let info = document.getElementById(INFO_ID);

    if (!info) {
      info = document.createElement('div');
      info.id = INFO_ID;
      info.className = 'mounting-description-box';

      info.innerHTML = `
        <div class="mounting-description-icon">ⓘ</div>
        <div class="mounting-description-text">
          Nakon porudžbine pripremićemo predlog dizajna prema unetim dimenzijama i dostaviti Vam ga zajedno sa konačnom cenom putem Vibera ili e-maila.<br>
          <strong>Proizvod izrađujemo tek nakon što odobrite dizajn i cenu.</strong>
        </div>
      `;
    }

    if (heightContainer.nextElementSibling !== info) {
      heightContainer.insertAdjacentElement('afterend', info);
    }

    info.style.setProperty('width', '100%', 'important');
    info.style.setProperty('max-width', '100%', 'important');
    info.style.setProperty('box-sizing', 'border-box', 'important');
    info.style.setProperty('grid-column', '1 / -1', 'important');
    info.style.setProperty('flex-basis', '100%', 'important');
    info.style.setProperty('margin-top', '-8px', 'important');
    info.style.setProperty('margin-bottom', '0px', 'important');

    return info;
  }

  function schedulePlacement() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      createOrMoveInfoBox();
    });
  }

  function initialize() {
    createOrMoveInfoBox();
    setTimeout(createOrMoveInfoBox, 300);
    setTimeout(createOrMoveInfoBox, 800);
    setTimeout(createOrMoveInfoBox, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  const observer = new MutationObserver(function () {
    schedulePlacement();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();


/* =========================================
   NESTANDARDNA DIMENZIJA – PRIKAZ POLJA
   ŠIRINA + VISINA + INFO
   ========================================= */

(function () {
  'use strict';

  const CUSTOM_VALUE = 'Nestandardna dimenzija';

  const CONTAINER_SELECTOR =
    '.tpo-option-container, .tpo_option-container';

  let scheduled = false;

  function clean(text) {
    return String(text || '')
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getContainerByLabel(labelName) {
    const containers = document.querySelectorAll(
      CONTAINER_SELECTOR
    );

    for (const container of containers) {
      const labels = container.querySelectorAll(
        '.tpo-option-label-container .form__label, ' +
        '.tpo_option-label-container .form__label, ' +
        '.form__label, label'
      );

      for (const label of labels) {
        const text = clean(label.textContent);

        if (
          text === labelName ||
          text.startsWith(labelName)
        ) {
          return container;
        }
      }
    }

    return null;
  }

  function customDimensionIsSelected() {
    const input = document.querySelector(
      '.dimension-card__input[value="' +
      CUSTOM_VALUE +
      '"]:checked'
    );

    return Boolean(input);
  }

  /*
    Easify pamti da su Širina i Visina Required.
    Zbog toga standardna dimenzija može da bude blokirana
    dok ta dva polja prvi put ne dobiju vrednost.

    Za standardnu dimenziju:
    - polja su sakrivena
    - ako su prazna, dobijaju privremenu validnu vrednost
    - uklanjamo "name" da se te privremene vrednosti NE šalju u korpu

    Za nestandardnu dimenziju:
    - vraćamo originalni "name"
    - privremene vrednosti brišemo
    - kupac mora stvarno da unese Širinu i Visinu
  */
  function prepareField(field, show, fallbackValue) {
    if (!field) return;

    if (!field.dataset.raccoonOriginalName && field.name) {
      field.dataset.raccoonOriginalName = field.name;
    }

    if (show) {
      if (
        !field.name &&
        field.dataset.raccoonOriginalName
      ) {
        field.name = field.dataset.raccoonOriginalName;
      }

      if (field.dataset.raccoonDummyValue === '1') {
        field.value = '';
        delete field.dataset.raccoonDummyValue;

        field.dispatchEvent(
          new Event('input', { bubbles: true })
        );
      }

      field.disabled = false;
      return;
    }

    /*
      Ako je kupac ranije uneo stvarnu vrednost,
      ne brišemo je. Samo je ne šaljemo dok je
      izabrana standardna dimenzija.
    */
    if (!String(field.value || '').trim()) {
      field.value = fallbackValue;
      field.dataset.raccoonDummyValue = '1';

      field.dispatchEvent(
        new Event('input', { bubbles: true })
      );
    }

    /*
      Ostavljamo input aktivnim da Easify vidi vrednost,
      ali bez name atributa browser ga neće poslati
      kao line-item property u korpu.
    */
    field.disabled = false;
    field.removeAttribute('name');
  }

  function setContainerVisibility(
    container,
    show,
    fallbackValue
  ) {
    if (!container) return;

    if (show) {
      container.style.removeProperty('display');
    } else {
      container.style.setProperty(
        'display',
        'none',
        'important'
      );
    }

    const fields = container.querySelectorAll(
      'input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]), ' +
      'textarea, select'
    );

    fields.forEach(function (field) {
      prepareField(
        field,
        show,
        fallbackValue
      );
    });

    if (!show) {
      container.removeAttribute('data-error');

      container
        .querySelectorAll('[data-error]')
        .forEach(function (element) {
          element.removeAttribute('data-error');
        });

      container
        .querySelectorAll(
          '.tpo_error-message, .tpo-error-message'
        )
        .forEach(function (message) {
          message.textContent = '';
          message.classList.remove('active');
        });
    }
  }

  function updateCustomDimensionFields() {
    const show = customDimensionIsSelected();

    const widthContainer =
      getContainerByLabel('Širina (cm)');

    const heightContainer =
      getContainerByLabel('Visina (cm)');

    const info =
      document.getElementById(
        'raccoon-custom-dimension-info'
      );

    setContainerVisibility(
      widthContainer,
      show,
      '6'
    );

    setContainerVisibility(
      heightContainer,
      show,
      '2'
    );

    if (info) {
      if (show) {
        info.style.removeProperty('display');
      } else {
        info.style.setProperty(
          'display',
          'none',
          'important'
        );
      }
    }
  }

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      updateCustomDimensionFields();
    });
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      const card =
        event.target.closest('.dimension-card');

      if (!card) return;

      setTimeout(scheduleUpdate, 0);
      setTimeout(scheduleUpdate, 100);
      setTimeout(scheduleUpdate, 300);
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      if (
        !event.target.matches(
          '.dimension-card__input'
        )
      ) {
        return;
      }

      setTimeout(scheduleUpdate, 0);
      setTimeout(scheduleUpdate, 100);
      setTimeout(scheduleUpdate, 300);
    },
    true
  );

  /*
    Dodatna zaštita neposredno pre Add to cart:
    kod standardne dimenzije još jednom pripremamo
    skrivena polja pre nego što Easify pokrene validaciju.
  */
  document.addEventListener(
    'pointerdown',
    function (event) {
      const addButton = event.target.closest(
        '.tpo_add-to-cart, .add-to-cart-button'
      );

      if (!addButton) return;

      if (!customDimensionIsSelected()) {
        updateCustomDimensionFields();
      }
    },
    true
  );

  const observer =
    new MutationObserver(function () {
      scheduleUpdate();
    });

  function initialize() {
    updateCustomDimensionFields();

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(
      updateCustomDimensionFields,
      300
    );

    setTimeout(
      updateCustomDimensionFields,
      800
    );

    setTimeout(
      updateCustomDimensionFields,
      1500
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }

})();

/* =========================================
   NESTANDARDNA DIMENZIJA – CENA NAKON PORUDŽBINE
   ========================================= */

(function () {
  'use strict';

  const CUSTOM_VALUE = 'Nestandardna dimenzija';
  const CUSTOM_TEXT = 'Cena nakon porudžbine';

  let scheduled = false;

  function getCustomInput() {
    return document.querySelector(
      '.dimension-card__input[value="' + CUSTOM_VALUE + '"]'
    );
  }

  function getCustomCard(input) {
    return input ? input.closest('.dimension-card') : null;
  }

  function updateCardPrice() {
    const input = getCustomInput();
    const card = getCustomCard(input);

    if (!card) return;

    const cardPrice = card.querySelector('.dimension-card__price');

    if (cardPrice && cardPrice.textContent.trim() !== CUSTOM_TEXT) {
      cardPrice.textContent = CUSTOM_TEXT;
    }
  }

  function updateMainPrice() {
    const input = getCustomInput();
    if (!input) return;

    const productRoot =
      input.closest('product-information, section, main') || document;

    const mainPrice = productRoot.querySelector(
      'product-price .price, product-price span.price'
    );

    if (!mainPrice) return;

    if (input.checked) {
      if (!mainPrice.dataset.originalPrice) {
        mainPrice.dataset.originalPrice = mainPrice.textContent.trim();
      }

      mainPrice.textContent = CUSTOM_TEXT;
    } else if (mainPrice.dataset.originalPrice) {
      /*
        Horizon će posle izbora standardne dimenzije sam postaviti
        novu cenu. Ovaj deo samo uklanja naš sačuvani status.
      */
      delete mainPrice.dataset.originalPrice;
    }
  }

  function updateCustomPrice() {
    updateCardPrice();
    updateMainPrice();
  }

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      updateCustomPrice();
    });
  }

  document.addEventListener('pointerdown', function (event) {
    if (!event.target.closest('.dimension-card')) return;

    setTimeout(scheduleUpdate, 0);
    setTimeout(scheduleUpdate, 100);
    setTimeout(scheduleUpdate, 300);
  }, true);

  document.addEventListener('change', function (event) {
    if (!event.target.matches('.dimension-card__input')) return;

    setTimeout(scheduleUpdate, 0);
    setTimeout(scheduleUpdate, 100);
    setTimeout(scheduleUpdate, 300);
  }, true);

  const observer = new MutationObserver(function () {
    scheduleUpdate();
  });

  function initialize() {
    updateCustomPrice();

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['checked', 'class', 'data-current-checked']
    });

    setTimeout(updateCustomPrice, 300);
    setTimeout(updateCustomPrice, 800);
    setTimeout(updateCustomPrice, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

})();

/* =========================================
   KORPA – CENA NESTANDARDNE DIMENZIJE
   ========================================= */

(function () {
  'use strict';

  const CUSTOM_DIMENSION = 'Nestandardna dimenzija';
  const CUSTOM_PRICE_TEXT = 'Cena nakon porudžbine';

  let scheduled = false;

  function updateCustomDimensionCartPrices() {
    const cartRows = document.querySelectorAll(
      'tr.cart-items__table-row, .cart-items__table-row'
    );

    cartRows.forEach(function (row) {
      const rowText = String(row.textContent || '')
        .replace(/\s+/g, ' ')
        .trim();

      /*
        Menjamo cenu samo ako taj red sadrži
        opciju „Nestandardna dimenzija“.
      */
      if (!rowText.includes(CUSTOM_DIMENSION)) return;

      const priceElements = row.querySelectorAll(
        '.tpo_cart_item_price, .cart-items__price text-component'
      );

      priceElements.forEach(function (priceElement) {
        if (priceElement.textContent.trim() !== CUSTOM_PRICE_TEXT) {
          priceElement.textContent = CUSTOM_PRICE_TEXT;
        }

        /*
          Horizon koristi i atribut value, pa menjamo i njega
          da ne bi odmah vratio 0.00 RSD.
        */
        if (priceElement.hasAttribute('value')) {
          priceElement.setAttribute('value', CUSTOM_PRICE_TEXT);
        }
      });
    });
  }

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      updateCustomDimensionCartPrices();
    });
  }

  /*
    Korpa se učitava i osvežava naknadno,
    pa pratimo promene koje pravi Horizon.
  */
  const observer = new MutationObserver(function () {
    scheduleUpdate();
  });

  function initialize() {
    updateCustomDimensionCartPrices();

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    setTimeout(updateCustomDimensionCartPrices, 300);
    setTimeout(updateCustomDimensionCartPrices, 800);
    setTimeout(updateCustomDimensionCartPrices, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();

/* =========================================
   NESTANDARDNA DIMENZIJA – FORMAT DIMENZIJA
   Samo brojevi; decimalna cifra može biti samo 0 ili 5
   Maksimalno: 2 cifre + tačka + 1 decimalna cifra
   ========================================= */

(function () {
  'use strict';

  const CONTAINER_SELECTOR =
    '.tpo-option-container, .tpo_option-container';

  function clean(text) {
    return String(text || '')
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isDimensionField(field) {
    if (!(field instanceof HTMLInputElement)) return false;

    const container = field.closest(CONTAINER_SELECTOR);
    if (!container) return false;

    const labels = container.querySelectorAll(
      '.tpo-option-label-container .form__label, ' +
      '.tpo_option-label-container .form__label, ' +
      '.form__label, label'
    );

    for (const label of labels) {
      const text = clean(label.textContent);

      if (
        text === 'Širina (cm)' ||
        text.startsWith('Širina (cm)') ||
        text === 'Visina (cm)' ||
        text.startsWith('Visina (cm)')
      ) {
        return true;
      }
    }

    return false;
  }

  function sanitizeDimension(field) {
    let value = String(field.value || '');

    /*
      Zarez se ponaša kao decimalna tačka.
    */
    value = value.replace(/,/g, '.');

    /*
      Brišemo sve osim cifara i tačke.
      Time nestaju slova, razmaci, +, -, e, E itd.
    */
    value = value.replace(/[^0-9.]/g, '');

    /*
      Ostavljamo samo prvu tačku.
    */
    const firstDot = value.indexOf('.');

    if (firstDot !== -1) {
      value =
        value.slice(0, firstDot + 1) +
        value.slice(firstDot + 1).replace(/\./g, '');
    }

    let integerPart = '';
    let decimalPart = '';

    if (value.includes('.')) {
      const parts = value.split('.');

      /*
        Maksimalno dve cifre pre tačke.
      */
      integerPart = (parts[0] || '')
        .replace(/\D/g, '')
        .slice(0, 2);

      /*
        Posle tačke dozvoljavamo samo PRVU cifru
        i ona može biti samo 0 ili 5.
      */
      const firstDecimalDigit = String(parts[1] || '').charAt(0);

      if (firstDecimalDigit === '0' || firstDecimalDigit === '5') {
        decimalPart = firstDecimalDigit;
      }

      /*
        Dozvoljavamo privremeno "12." dok kupac kuca.
      */
      value = integerPart + '.' + decimalPart;

    } else {

      /*
        Bez decimale maksimalno dve cifre.
      */
      value = value
        .replace(/\D/g, '')
        .slice(0, 2);
    }

    if (field.value !== value) {
      field.value = value;
    }
  }

  /*
    Sprečava unos nedozvoljenih znakova PRE nego što
    stignu u polje. Kontrola kroz input ispod ostaje
    kao dodatna zaštita za paste/autofill.
  */
  document.addEventListener(
    'keydown',
    function (event) {
      const field = event.target;

      if (!isDimensionField(field)) return;

      /*
        Navigacija i uređivanje moraju normalno da rade.
      */
      const allowedControlKeys = [
        'Backspace',
        'Delete',
        'ArrowLeft',
        'ArrowRight',
        'ArrowUp',
        'ArrowDown',
        'Home',
        'End',
        'Tab',
        'Enter'
      ];

      if (
        allowedControlKeys.includes(event.key) ||
        event.ctrlKey ||
        event.metaKey
      ) {
        return;
      }

      /*
        Zarez pretvaramo u tačku.
      */
      if (event.key === ',') {
        event.preventDefault();

        if (!field.value.includes('.')) {
          const start =
            typeof field.selectionStart === 'number'
              ? field.selectionStart
              : field.value.length;

          const end =
            typeof field.selectionEnd === 'number'
              ? field.selectionEnd
              : start;

          field.setRangeText('.', start, end, 'end');

          field.dispatchEvent(
            new Event('input', { bubbles: true })
          );
        }

        return;
      }

      /*
        Tačka je dozvoljena samo jednom.
      */
      if (event.key === '.') {
        if (field.value.includes('.')) {
          event.preventDefault();
        }

        return;
      }

      /*
        Sve što nije cifra odmah blokiramo.
      */
      if (!/^[0-9]$/.test(event.key)) {
        event.preventDefault();
        return;
      }

      /*
        Ako je kursor iza tačke, decimalna cifra
        može biti samo 0 ili 5.
      */
      const value = String(field.value || '');
      const dotIndex = value.indexOf('.');
      const cursor =
        typeof field.selectionStart === 'number'
          ? field.selectionStart
          : value.length;

      if (
        dotIndex !== -1 &&
        cursor > dotIndex &&
        event.key !== '0' &&
        event.key !== '5'
      ) {
        event.preventDefault();
      }
    },
    true
  );

  document.addEventListener(
    'input',
    function (event) {
      const field = event.target;

      if (!isDimensionField(field)) return;

      sanitizeDimension(field);
    },
    true
  );

  /*
    Kada kupac napusti polje i ostavi npr. "12.",
    automatski ga pretvaramo u "12.0".
  */
  document.addEventListener(
    'focusout',
    function (event) {
      const field = event.target;

      if (!isDimensionField(field)) return;

      if (String(field.value || '').endsWith('.')) {
        field.value += '0';

        field.dispatchEvent(
          new Event('input', { bubbles: true })
        );

        field.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }
    },
    true
  );

  /*
    Na telefonu tražimo decimalnu numeričku tastaturu.
    Easify može naknadno da kreira polja, zato ovo
    ponavljamo preko MutationObserver-a.
  */
  function prepareDimensionFields() {
    document.querySelectorAll(
      CONTAINER_SELECTOR + ' input'
    ).forEach(function (field) {
      if (!isDimensionField(field)) return;

      field.setAttribute('inputmode', 'decimal');
      field.setAttribute('autocomplete', 'off');
    });
  }

  let scheduled = false;

  const observer = new MutationObserver(function () {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      prepareDimensionFields();
    });
  });

  function initialize() {
    prepareDimensionFields();

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(prepareDimensionFields, 300);
    setTimeout(prepareDimensionFields, 800);
    setTimeout(prepareDimensionFields, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }

})();

/* =========================================
   NESTANDARDNA DIMENZIJA – SPOJENA VREDNOST IZNAD POLJA
   Prikaz: 20.5 × 15.5 cm
   ========================================= */

(function () {
  'use strict';

  const CONTAINER_SELECTOR =
    '.tpo-option-container, .tpo_option-container';

  const VALUE_ID = 'raccoon-dimension-combined-value';
  let scheduled = false;

  function clean(text) {
    return String(text || '')
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getContainerByLabel(labelName) {
    const containers = document.querySelectorAll(
      CONTAINER_SELECTOR
    );

    for (const container of containers) {
      const labels = container.querySelectorAll(
        '.tpo-option-label-container .form__label, ' +
        '.tpo_option-label-container .form__label, ' +
        '.form__label, label'
      );

      for (const label of labels) {
        const text = clean(label.textContent);

        if (
          text === labelName ||
          text.startsWith(labelName)
        ) {
          return container;
        }
      }
    }

    return null;
  }

  function getField(container) {
    if (!container) return null;

    return container.querySelector(
      'input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"])'
    );
  }

  function createOrMoveValue() {
    const widthContainer = getContainerByLabel('Širina (cm)');
    const heightContainer = getContainerByLabel('Visina (cm)');

    if (
      !widthContainer ||
      !heightContainer ||
      !widthContainer.parentElement
    ) {
      return;
    }

    const widthField = getField(widthContainer);
    const heightField = getField(heightContainer);

    if (!widthField || !heightField) return;

    let valueBox = document.getElementById(VALUE_ID);

    if (!valueBox) {
      valueBox = document.createElement('div');
      valueBox.id = VALUE_ID;
    }

    /*
      Postavljamo vrednost kao poseban red IZNAD oba polja.
      Ne ubacujemo je više u labelu "Širina", pa naslov
      ostaje normalno poravnat i ne prelama se.
    */
    if (widthContainer.previousElementSibling !== valueBox) {
      widthContainer.insertAdjacentElement(
        'beforebegin',
        valueBox
      );
    }

    valueBox.style.setProperty(
      'width',
      '100%',
      'important'
    );

    valueBox.style.setProperty(
      'max-width',
      '100%',
      'important'
    );

    valueBox.style.setProperty(
      'box-sizing',
      'border-box',
      'important'
    );

    valueBox.style.setProperty(
      'grid-column',
      '1 / -1',
      'important'
    );

    valueBox.style.setProperty(
      'flex-basis',
      '100%',
      'important'
    );

    valueBox.style.setProperty(
      'text-align',
      'right',
      'important'
    );

    valueBox.style.setProperty(
      'color',
      '#7a7a7a',
      'important'
    );

    valueBox.style.setProperty(
      'font-weight',
      '600',
      'important'
    );

    valueBox.style.setProperty(
      'font-size',
      'inherit',
      'important'
    );

    valueBox.style.setProperty(
      'line-height',
      '1.2',
      'important'
    );

    valueBox.style.setProperty(
      'margin',
      '0 0 2px 0',
      'important'
    );

    function displayDimension(value) {
      value = String(value || '').trim();

      if (/^\d+\.0$/.test(value)) {
        return value.slice(0, -2);
      }

      return value;
    }

    const widthValue = displayDimension(widthField.value);
    const heightValue = displayDimension(heightField.value);

    const customInput = document.querySelector(
      '.dimension-card__input[value="Nestandardna dimenzija"]:checked'
    );

    if (customInput && widthValue && heightValue) {
      valueBox.textContent =
        widthValue + ' × ' + heightValue + ' cm';

      valueBox.style.removeProperty('display');
    } else {
      valueBox.textContent = '';
      valueBox.style.setProperty(
        'display',
        'none',
        'important'
      );
    }
  }

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      createOrMoveValue();
    });
  }

  document.addEventListener(
    'input',
    function (event) {
      const container = event.target.closest
        ? event.target.closest(CONTAINER_SELECTOR)
        : null;

      if (!container) return;

      const text = clean(container.textContent);

      if (
        !text.includes('Širina (cm)') &&
        !text.includes('Visina (cm)')
      ) {
        return;
      }

      scheduleUpdate();
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      const container = event.target.closest
        ? event.target.closest(CONTAINER_SELECTOR)
        : null;

      if (!container) return;

      const text = clean(container.textContent);

      if (
        !text.includes('Širina (cm)') &&
        !text.includes('Visina (cm)')
      ) {
        return;
      }

      scheduleUpdate();
    },
    true
  );

  const observer = new MutationObserver(function () {
    scheduleUpdate();
  });

  function initialize() {
    createOrMoveValue();

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(createOrMoveValue, 300);
    setTimeout(createOrMoveValue, 800);
    setTimeout(createOrMoveValue, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }

})();


/* =========================================
   FONT – 6 KARTICA 3x2 + PREVIEW OTVORENO
   Preview prati izbor pisma:
   Ćirilica  -> ОТВОРЕНО
   Latinica  -> OTVORENO
   ========================================= */

(function () {
  'use strict';

  const CONTAINER_SELECTOR =
    '.tpo-option-container, .tpo_option-container';

  const STYLE_ID = 'raccoon-font-cards-style';

  let scheduled = false;

  function clean(value) {
    return String(value || '')
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getContainerByLabel(labelName) {
    const containers = document.querySelectorAll(
      CONTAINER_SELECTOR
    );

    for (const container of containers) {
      const labels = container.querySelectorAll(
        '.tpo-option-label-container .form__label, ' +
        '.tpo_option-label-container .form__label, ' +
        '.form__label, label'
      );

      for (const label of labels) {
        const text = clean(label.textContent);

        if (
          text === labelName ||
          text.startsWith(labelName)
        ) {
          return container;
        }
      }
    }

    return null;
  }

  function getSelectedPismo() {
    const container = getContainerByLabel('Pismo');

    if (!container) return 'Ћирилица';

    const checked = container.querySelector(
      'input[type="radio"]:checked, input.tpo_buttons-input:checked'
    );

    if (checked) {
      const value = clean(checked.value);

      if (value === 'Ћирилица' || value === 'Latinica') {
        return value;
      }
    }

    const selected = container.querySelector(
      'label.tpo_is_checked_swatches, .tpo_is_checked_swatches'
    );

    if (selected) {
      const input = selected.querySelector('input');

      const value = clean(
        selected.getAttribute('data-color-name') ||
        (input && input.value) ||
        selected.textContent
      );

      if (value === 'Ћирилица' || value === 'Latinica') {
        return value;
      }
    }

    return 'Ћирилица';
  }

  function getTextFieldByLabel(labelName) {
    const containers =
      document.querySelectorAll(CONTAINER_SELECTOR);

    const matching = [];

    for (const container of containers) {
      const label = container.querySelector(
        '.tpo-option-label-container .form__label, ' +
        '.tpo_option-label-container .form__label, ' +
        '.form__label'
      );

      const labelText = label
        ? clean(label.textContent).replace(/\s*\*$/, '')
        : '';

      if (labelText === labelName) {
        matching.push(container);
      }
    }

    if (!matching.length) return null;

    /*
      Samo Prezime | Natpis ima dve moguće vrste polja.
      Metafield "Dva reda" bira textarea.
      Prazan metafield / Jedan red bira običan input.
    */
    if (labelName === 'Prezime | Natpis') {
      const data = document.getElementById(
        'raccoon-product-data'
      );

      const twoLines =
        data &&
        String(
          data.dataset.raccoonTextLayout || ''
        ).trim() === 'Dva reda';

      if (twoLines) {
        for (const container of matching) {
          const textarea = container.querySelector('textarea');

          if (textarea) return textarea;
        }
      } else {
        for (const container of matching) {
          const input = container.querySelector(
            'input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"])'
          );

          if (input) return input;
        }
      }
    }

    for (const container of matching) {
      const field = container.querySelector(
        'input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]), textarea'
      );

      if (field) return field;
    }

    return null;
  }

  function getPreviewText() {
    /*
      Pločica za vrata:
      ako postoji polje "Prezime | Natpis", preview prikazuje
      ono što kupac unese u "Prezime | Natpis" i "Broj".

      Otvoreno/Zatvoreno:
      ako tog polja nema, ostaje OTVORENO / ZATVORENO.
    */
    const nameField =
      getTextFieldByLabel('Prezime | Natpis');

    if (nameField) {
      const numberField =
        getTextFieldByLabel('Broj');

      const pismo =
        getSelectedPismo();

      const nameValue =
        String(nameField.value || '').trim();

      const numberValue =
        numberField
          ? String(numberField.value || '').trim()
          : '';

      const fallbackName =
        pismo === 'Latinica'
          ? 'PREZIME'
          : 'ПРЕЗИМЕ';

      /*
        Ako proizvod nema polje "Broj",
        Font preview prikazuje samo Prezime | Natpis.
      */
      if (!numberField) {
        return nameValue || fallbackName;
      }

      const fallbackNumber =
        pismo === 'Latinica'
          ? 'BROJ'
          : 'БРОЈ';

      return (
        (nameValue || fallbackName) +
        '\n' +
        (numberValue || fallbackNumber)
      );
    }

    return getSelectedPismo() === 'Latinica'
      ? 'OTVORENO\nZATVORENO'
      : 'ОТВОРЕНО\nЗАТВОРЕНО';
  }

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;

    style.textContent = `
      .raccoon-font-container,
      .raccoon-font-container .tpo-option-input-wrapper,
      .raccoon-font-container .tpo_option-input-wrapper,
      .raccoon-font-container .tpo-option-input,
      .raccoon-font-container .tpo_option-input {
        width: 100% !important;
        max-width: none !important;
        flex-basis: 100% !important;
      }

      .raccoon-font-grid {
        display: grid !important;
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        column-gap: 8px !important;
        row-gap: 8px !important;
        width: 100% !important;
        max-width: none !important;
        flex: 1 1 100% !important;
        box-sizing: border-box !important;
      }

      .raccoon-font-grid > label {
        width: 100% !important;
        min-width: 0 !important;
        max-width: none !important;

        height: 96px !important;
        min-height: 96px !important;
        max-height: 96px !important;

        margin: 0 !important;
        flex: none !important;
        box-sizing: border-box !important;
      }

      /*
        Easify na nekim uređajima stavlja dodatni wrapper oko label-a.
        Menjamo SAMO širinu tog label-a, bez diranja njegovog izgleda,
        visine, bordera ili selected stila.
      */
      .raccoon-font-grid > * > label {
        width: 100% !important;
        min-width: 0 !important;
        max-width: none !important;

        height: 96px !important;
        min-height: 96px !important;
        max-height: 96px !important;

        margin: 0 !important;
        box-sizing: border-box !important;
      }

      .raccoon-font-grid > label .raccoon-font-card {
        width: 100% !important;

        height: 96px !important;
        min-height: 96px !important;
        max-height: 96px !important;

        padding: 8px 8px !important;
        border: 2px solid #777777 !important;
        border-radius: 7px !important;
        background: #ffffff !important;
        color: #777777 !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 7px !important;
        text-align: center !important;
        box-sizing: border-box !important;
        transition:
          border-color .2s ease,
          background-color .2s ease,
          color .2s ease,
          box-shadow .2s ease,
          transform .2s ease !important;
      }

      .raccoon-font-grid > label:hover .raccoon-font-card {
        border-color: #1fa1ae !important;
      }

      .raccoon-font-grid > label.tpo_is_checked_swatches .raccoon-font-card,
      .raccoon-font-grid > label:has(input:checked) .raccoon-font-card {
        border-color: #1fa1ae !important;
        background: #292929 !important;
        color: #ffffff !important;
      }

      .raccoon-font-preview {
        display: block !important;
        width: 100% !important;
        text-align: center !important;
        margin-left: auto !important;
        margin-right: auto !important;
        font-size: 20px !important;
        line-height: 1.1 !important;
        font-weight: 700 !important;
        /*
          Čuvamo ISKLJUČIVO redove koje je kupac napravio Enterom.
          Browser više ne sme sam da prelama dugačak tekst.
        */
        white-space: pre !important;
        overflow: hidden !important;
        text-overflow: clip !important;
      }

      .raccoon-font-preview-name,
      .raccoon-font-preview-number {
        display: block !important;
        width: 100% !important;
        line-height: 1.1 !important;
        text-align: center !important;
      }

      .raccoon-font-preview-name {
        white-space: pre !important;
      }

      .raccoon-font-preview-number {
        white-space: nowrap !important;
        flex-shrink: 0 !important;
      }

      .raccoon-font-name {
        display: block !important;
        width: 100% !important;
        text-align: center !important;
        margin-left: auto !important;
        margin-right: auto !important;
        font-family: var(--font-body-family), sans-serif !important;
        font-size: 12px !important;
        line-height: 1.1 !important;
        font-weight: 600 !important;
        color: inherit !important;
        opacity: .95 !important;
      }

      @media screen and (max-width: 749px) {
        .raccoon-font-grid {
          grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
          column-gap: 8px !important;
          row-gap: 8px !important;
        }

        .raccoon-font-grid > label,
        .raccoon-font-grid > * > label {
          height: 86px !important;
          min-height: 86px !important;
          max-height: 86px !important;
        }

        .raccoon-font-grid > label .raccoon-font-card {
          height: 86px !important;
          min-height: 86px !important;
          max-height: 86px !important;

          padding: 8px 6px !important;
        }

        .raccoon-font-preview {
          font-size: 17px !important;
        }

        .raccoon-font-name {
          font-size: 11px !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function getFontFamily(fontName) {
    const map = {
      'Montserrat':
        '"Montserrat", Arial, sans-serif',

      'Playfair Display':
        '"Playfair Display", Georgia, serif',

      'Lobster':
        '"Lobster", cursive',

      'Nunito':
        '"Nunito", Arial, sans-serif',

      'PT Serif':
        '"PT Serif", Georgia, serif',

      'Pacifico':
        '"Pacifico", cursive'
    };

    return map[fontName] || 'inherit';
  }

  function getFontWeight(fontName) {
    /*
      Ova četiri Google fonta učitavamo u pravoj Bold 700 debljini.
      Lobster i Pacifico nemaju klasičnu 700 varijantu u Google Fonts,
      pa ih prikazujemo u njihovoj originalnoj debljini.
    */
    if (
      fontName === 'Montserrat' ||
      fontName === 'Playfair Display' ||
      fontName === 'Nunito' ||
      fontName === 'PT Serif'
    ) {
      return '700';
    }

    return '400';
  }

  function fitFontPreviewToCard(preview) {
    if (!preview) return;

    const mobile =
      window.matchMedia &&
      window.matchMedia('(max-width: 749px)').matches;

    const startSize = mobile ? 17 : 20;
    const minSize = 10;

    /*
      Važno:
      - NE dodajemo nove redove.
      - Ako je jedan red predugačak, samo smanjujemo veličinu
        fonta dok ceo red ne stane u karticu.
      - Ako je kupac pritisnuo Enter, taj Enter ostaje.
    */
    preview.style.setProperty(
      'white-space',
      'pre',
      'important'
    );

    preview.style.setProperty(
      'font-size',
      startSize + 'px',
      'important'
    );

    let size = startSize;
    const availableWidth = preview.clientWidth;

    if (!availableWidth) return;

    while (
      size > minSize &&
      preview.scrollWidth > availableWidth + 1
    ) {
      size -= 0.5;

      preview.style.setProperty(
        'font-size',
        size + 'px',
        'important'
      );
    }
  }

  function getButtonWrapper(container) {
    if (!container) return null;

    return container.querySelector(
      '.tpo_buttons-wrapper, ' +
      '.tpo-buttons-wrapper, ' +
      '[class*="buttons-wrapper"]'
    );
  }

  function prepareFontCards() {
    addStyles();

    const container = getContainerByLabel('Font');

    if (!container) return;

    container.classList.add('raccoon-font-container');

    const wrapper = getButtonWrapper(container);

    if (!wrapper) return;

    wrapper.classList.add('raccoon-font-grid');

    const previewText = getPreviewText();

    const labels = wrapper.querySelectorAll('label');

    labels.forEach(function (label) {
      const input = label.querySelector(
        'input[type="radio"], input.tpo_buttons-input'
      );

      if (!input || !input.value) return;

      const fontName = clean(input.value);

      let card = label.querySelector(
        '.raccoon-font-card'
      );

      if (!card) {
        /*
          Skrivamo samo originalni tekst dugmeta,
          ali ostavljamo Easify input i label funkcionalnim.
        */
        Array.from(label.childNodes).forEach(function (node) {
          if (
            node.nodeType === Node.TEXT_NODE &&
            clean(node.textContent)
          ) {
            node.textContent = '';
          }
        });

        label.querySelectorAll(
          'span:not(.raccoon-font-card):not(.tpo_additional-price)'
        ).forEach(function (span) {
          const text = clean(span.textContent);

          if (text === fontName) {
            span.style.setProperty(
              'display',
              'none',
              'important'
            );
          }
        });

        card = document.createElement('span');
        card.className = 'raccoon-font-card';

        const preview = document.createElement('span');
        preview.className = 'raccoon-font-preview';

        const previewName = document.createElement('span');
        previewName.className = 'raccoon-font-preview-name';

        const previewNumber = document.createElement('span');
        previewNumber.className = 'raccoon-font-preview-number';

        preview.appendChild(previewName);
        preview.appendChild(previewNumber);

        const name = document.createElement('span');
        name.className = 'raccoon-font-name';
        name.textContent = fontName;

        card.appendChild(preview);
        card.appendChild(name);

        label.appendChild(card);
      }

      const preview = card.querySelector(
        '.raccoon-font-preview'
      );

      const name = card.querySelector(
        '.raccoon-font-name'
      );

      if (preview) {
        const nameField =
          getTextFieldByLabel('Prezime | Natpis');

        if (nameField) {
          const numberField =
            getTextFieldByLabel('Broj');

          const pismo =
            getSelectedPismo();

          const nameValue =
            String(nameField.value || '').trim();

          const numberValue =
            numberField
              ? String(numberField.value || '').trim()
              : '';

          const fallbackName =
            pismo === 'Latinica'
              ? 'PREZIME'
              : 'ПРЕЗИМЕ';

          const fallbackNumber =
            pismo === 'Latinica'
              ? 'BROJ'
              : 'БРОЈ';

          let previewName = preview.querySelector(
            '.raccoon-font-preview-name'
          );

          let previewNumber = preview.querySelector(
            '.raccoon-font-preview-number'
          );

          if (!previewName || !previewNumber) {
            preview.textContent = '';

            previewName =
              document.createElement('span');

            previewName.className =
              'raccoon-font-preview-name';

            previewNumber =
              document.createElement('span');

            previewNumber.className =
              'raccoon-font-preview-number';

            preview.appendChild(previewName);
            preview.appendChild(previewNumber);
          }

          previewName.textContent =
            nameValue || fallbackName;

          /*
            Broj prikazujemo samo na proizvodima
            koji stvarno imaju Easify polje "Broj".
          */
          if (numberField) {
            previewNumber.textContent =
              numberValue || fallbackNumber;

            previewNumber.style.removeProperty(
              'display'
            );
          } else {
            previewNumber.textContent = '';

            previewNumber.style.setProperty(
              'display',
              'none',
              'important'
            );
          }

          preview.style.setProperty(
            'font-family',
            getFontFamily(fontName),
            'important'
          );

          preview.style.setProperty(
            'font-weight',
            getFontWeight(fontName),
            'important'
          );

          /*
            Smanjujemo SAMO Prezime | Natpis.
            Broj uvek ostaje na početnoj veličini fonta.
          */
          requestAnimationFrame(function () {
            fitFontPreviewToCard(previewName);

            const mobile =
              window.matchMedia &&
              window.matchMedia(
                '(max-width: 749px)'
              ).matches;

            if (numberField) {
              previewNumber.style.setProperty(
                'font-size',
                (mobile ? 17 : 20) + 'px',
                'important'
              );
            }
          });

          setTimeout(function () {
            fitFontPreviewToCard(previewName);
          }, 120);
        } else {
          /*
            Otvoreno / Zatvoreno ostaje potpuno isto
            kao do sada.
          */
          preview.textContent = previewText;

          preview.style.setProperty(
            'font-family',
            getFontFamily(fontName),
            'important'
          );

          preview.style.setProperty(
            'font-weight',
            getFontWeight(fontName),
            'important'
          );

          requestAnimationFrame(function () {
            fitFontPreviewToCard(preview);
          });

          setTimeout(function () {
            fitFontPreviewToCard(preview);
          }, 120);
        }
      }

      if (name) {
        name.textContent = fontName;
      }
    });
  }

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      prepareFontCards();
    });
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      const label = event.target.closest(
        '.tpo_buttons-wrapper label, ' +
        '.tpo-buttons-wrapper label, label'
      );

      if (!label) return;

      const pismoContainer =
        getContainerByLabel('Pismo');

      const labelContainer =
        label.closest(CONTAINER_SELECTOR);

      if (
        pismoContainer &&
        labelContainer === pismoContainer
      ) {
        setTimeout(scheduleUpdate, 0);
        setTimeout(scheduleUpdate, 100);
        setTimeout(scheduleUpdate, 300);
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      const field = event.target;

      if (!(field instanceof HTMLInputElement)) {
        return;
      }

      const container =
        field.closest(CONTAINER_SELECTOR);

      const pismoContainer =
        getContainerByLabel('Pismo');

      const fontContainer =
        getContainerByLabel('Font');

      const nameContainer =
        getContainerByLabel('Prezime | Natpis');

      const numberContainer =
        getContainerByLabel('Broj');

      if (
        container === pismoContainer ||
        container === fontContainer ||
        container === nameContainer ||
        container === numberContainer
      ) {
        setTimeout(scheduleUpdate, 0);
        setTimeout(scheduleUpdate, 100);
      }
    },
    true
  );

  /*
    Na Pločici za vrata osveži preview odmah dok kupac
    kuca Prezime | Natpis ili Broj.
  */
  document.addEventListener(
    'input',
    function (event) {
      const field = event.target;

      if (
        !(field instanceof HTMLInputElement) &&
        !(field instanceof HTMLTextAreaElement)
      ) {
        return;
      }

      const container =
        field.closest(CONTAINER_SELECTOR);

      const nameContainer =
        getContainerByLabel('Prezime | Natpis');

      const numberContainer =
        getContainerByLabel('Broj');

      if (
        container === nameContainer ||
        container === numberContainer
      ) {
        scheduleUpdate();
      }
    },
    true
  );

  const observer =
    new MutationObserver(function () {
      scheduleUpdate();
    });

  function initialize() {
    prepareFontCards();

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'class',
        'checked',
        'data-color-name'
      ]
    });

    setTimeout(prepareFontCards, 300);
    setTimeout(prepareFontCards, 800);
    setTimeout(prepareFontCards, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }

})();


/* =========================================
   FONT – IZABRANA VREDNOST DESNO OD NASLOVA
   ========================================= */

(function () {
  'use strict';

  const CONTAINER_SELECTOR =
    '.tpo-option-container, .tpo_option-container';

  let scheduled = false;

  function clean(value) {
    return String(value || '')
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getFontContainer() {
    const containers =
      document.querySelectorAll(CONTAINER_SELECTOR);

    for (const container of containers) {
      const label = container.querySelector(
        '.tpo-option-label-container .form__label, ' +
        '.tpo_option-label-container .form__label'
      );

      if (label && clean(label.textContent) === 'Font') {
        return container;
      }
    }

    return null;
  }

  function getSelectedFont(container) {
    if (!container) return '';

    const checked = container.querySelector(
      'input[type="radio"]:checked, ' +
      'input.tpo_buttons-input:checked'
    );

    if (checked && checked.value) {
      return clean(checked.value);
    }

    const selectedLabel = container.querySelector(
      'label.tpo_is_checked_swatches'
    );

    if (selectedLabel) {
      const input = selectedLabel.querySelector('input');

      return clean(
        selectedLabel.getAttribute('data-color-name') ||
        (input && input.value) ||
        ''
      );
    }

    return '';
  }

  function getOrCreateSelectedSpan(container) {
    const labelContainer = container.querySelector(
      '.tpo-option-label-container, ' +
      '.tpo_option-label-container'
    );

    if (!labelContainer) return null;

    let selectedSpan = labelContainer.querySelector(
      '.tpo_selected_values_span'
    );

    if (!selectedSpan) {
      selectedSpan = document.createElement('span');
      selectedSpan.className =
        'tpo_selected_values_span raccoon-font-selected-value';

      labelContainer.appendChild(selectedSpan);
    } else {
      selectedSpan.classList.add(
        'raccoon-font-selected-value'
      );
    }

    labelContainer.style.setProperty(
      'display',
      'flex',
      'important'
    );

    labelContainer.style.setProperty(
      'align-items',
      'center',
      'important'
    );

    labelContainer.style.setProperty(
      'justify-content',
      'space-between',
      'important'
    );

    labelContainer.style.setProperty(
      'width',
      '100%',
      'important'
    );

    selectedSpan.style.setProperty(
      'margin-left',
      'auto',
      'important'
    );

    selectedSpan.style.setProperty(
      'text-align',
      'right',
      'important'
    );

    selectedSpan.style.setProperty(
      'color',
      '#777777',
      'important'
    );

    selectedSpan.style.setProperty(
      'font-weight',
      '600',
      'important'
    );

    return selectedSpan;
  }

  function displaySelectedFont(forcedValue) {
    const container = getFontContainer();

    if (!container) return;

    const selectedSpan =
      getOrCreateSelectedSpan(container);

    if (!selectedSpan) return;

    const value =
      clean(forcedValue) ||
      getSelectedFont(container);

    if (!value) return;

    if (selectedSpan.textContent.trim() !== value) {
      selectedSpan.textContent = value;
    }
  }

  function fontFromLabel(label) {
    if (!label) return '';

    const input = label.querySelector(
      'input[type="radio"], input.tpo_buttons-input'
    );

    return clean(
      label.getAttribute('data-color-name') ||
      (input && input.value) ||
      ''
    );
  }

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      displaySelectedFont();
    });
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      const container = getFontContainer();

      if (!container) return;

      const label = event.target.closest(
        '.raccoon-font-grid label'
      );

      if (!label || !container.contains(label)) return;

      const value = fontFromLabel(label);

      if (value) {
        displaySelectedFont(value);
      }

      setTimeout(scheduleUpdate, 0);
      setTimeout(scheduleUpdate, 100);
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      const container = getFontContainer();

      if (!container || !container.contains(event.target)) {
        return;
      }

      if (
        event.target.matches(
          'input[type="radio"], input.tpo_buttons-input'
        )
      ) {
        displaySelectedFont(event.target.value);
        setTimeout(scheduleUpdate, 0);
      }
    },
    true
  );

  const observer =
    new MutationObserver(function () {
      scheduleUpdate();
    });

  function initialize() {
    displaySelectedFont();

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'class',
        'checked',
        'data-color-name'
      ]
    });

    setTimeout(displaySelectedFont, 300);
    setTimeout(displaySelectedFont, 800);
    setTimeout(displaySelectedFont, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }

})();


/* =========================================
   IZGLED TEKSTA – IZABRANA VREDNOST DESNO
   ========================================= */

(function () {
  'use strict';

  const CONTAINER_SELECTOR =
    '.tpo-option-container, .tpo_option-container';

  let scheduled = false;

  function clean(value) {
    return String(value || '')
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getContainer() {
    const containers = document.querySelectorAll(CONTAINER_SELECTOR);

    for (const container of containers) {
      const label = container.querySelector(
        '.tpo-option-label-container .form__label, ' +
        '.tpo_option-label-container .form__label'
      );

      if (label && clean(label.textContent) === 'Izgled teksta') {
        return container;
      }
    }

    return null;
  }

  function selectedValue(container) {
    if (!container) return 'Sva velika slova';

    const checked = container.querySelector(
      'input[type="radio"]:checked, input.tpo_buttons-input:checked'
    );

    if (checked && checked.value) {
      const value = clean(checked.value);

      if (
        value === 'Sva velika slova' ||
        value === 'Kako je upisano'
      ) {
        return value;
      }
    }

    const selectedLabel = container.querySelector(
      'label.tpo_is_checked_swatches'
    );

    if (selectedLabel) {
      const input = selectedLabel.querySelector('input');
      const value = clean(
        selectedLabel.getAttribute('data-color-name') ||
        (input && input.value) ||
        ''
      );

      if (
        value === 'Sva velika slova' ||
        value === 'Kako je upisano'
      ) {
        return value;
      }
    }

    return 'Sva velika slova';
  }

  function getOrCreateSpan(container) {
    const labelContainer = container.querySelector(
      '.tpo-option-label-container, .tpo_option-label-container'
    );

    if (!labelContainer) return null;

    let span = labelContainer.querySelector(
      '.tpo_selected_values_span'
    );

    if (!span) {
      span = document.createElement('span');
      span.className =
        'tpo_selected_values_span raccoon-text-appearance-selected-value';
      labelContainer.appendChild(span);
    }

    labelContainer.style.setProperty('display', 'flex', 'important');
    labelContainer.style.setProperty('align-items', 'center', 'important');
    labelContainer.style.setProperty('justify-content', 'space-between', 'important');
    labelContainer.style.setProperty('width', '100%', 'important');

    span.style.setProperty('margin-left', 'auto', 'important');
    span.style.setProperty('text-align', 'right', 'important');
    span.style.setProperty('color', '#777777', 'important');
    span.style.setProperty('font-weight', '600', 'important');
    span.style.setProperty('font-size', '16px', 'important');
    span.style.setProperty('line-height', '1.3', 'important');
    span.style.setProperty('white-space', 'nowrap', 'important');

    return span;
  }

  function display(forcedValue) {
    const container = getContainer();
    if (!container) return;

    const span = getOrCreateSpan(container);
    if (!span) return;

    const value = clean(forcedValue) || selectedValue(container);

    if (
      value !== 'Sva velika slova' &&
      value !== 'Kako je upisano'
    ) {
      return;
    }

    span.textContent = value;
  }

  function valueFromLabel(label) {
    if (!label) return '';

    const input = label.querySelector(
      'input[type="radio"], input.tpo_buttons-input'
    );

    return clean(
      label.getAttribute('data-color-name') ||
      (input && input.value) ||
      ''
    );
  }

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      display();
    });
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      const container = getContainer();
      if (!container) return;

      const label = event.target.closest(
        '.tpo_buttons-wrapper label'
      );

      if (!label || !container.contains(label)) return;

      const value = valueFromLabel(label);

      if (
        value === 'Sva velika slova' ||
        value === 'Kako je upisano'
      ) {
        display(value);
      }

      setTimeout(scheduleUpdate, 0);
      setTimeout(scheduleUpdate, 100);
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      const container = getContainer();

      if (!container || !container.contains(event.target)) {
        return;
      }

      if (
        event.target.matches(
          'input[type="radio"], input.tpo_buttons-input'
        )
      ) {
        display(event.target.value);
        setTimeout(scheduleUpdate, 0);
      }
    },
    true
  );

  const observer = new MutationObserver(scheduleUpdate);

  function initialize() {
    display();

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'checked', 'data-color-name']
    });

    setTimeout(display, 300);
    setTimeout(display, 800);
    setTimeout(display, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

})();



/* =========================================
   PREZIME | NATPIS – IZGLED TEKSTA
   SVA VELIKA SLOVA / KAKO JE UPISANO
   ========================================= */

(function () {
  'use strict';

  const CONTAINER_SELECTOR =
    '.tpo-option-container, .tpo_option-container';

  let internalChange = false;
  let lastMode = null;

  function clean(value) {
    return String(value || '')
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getLabelText(container) {
    if (!container) return '';

    const label = container.querySelector(
      '.tpo-option-label-container .form__label, ' +
      '.tpo_option-label-container .form__label, ' +
      '.form__label'
    );

    return label
      ? clean(label.textContent).replace(/\s*\*$/, '')
      : '';
  }

  function getContainerByLabel(labelName) {
    const containers =
      document.querySelectorAll(CONTAINER_SELECTOR);

    for (const container of containers) {
      if (getLabelText(container) === labelName) {
        return container;
      }
    }

    return null;
  }

  function getTextField() {
    const containers =
      document.querySelectorAll(CONTAINER_SELECTOR);

    const matching = [];

    for (const container of containers) {
      if (getLabelText(container) === 'Prezime | Natpis') {
        matching.push(container);
      }
    }

    if (!matching.length) return null;

    const data = document.getElementById(
      'raccoon-product-data'
    );

    const twoLines =
      data &&
      String(
        data.dataset.raccoonTextLayout || ''
      ).trim() === 'Dva reda';

    if (twoLines) {
      for (const container of matching) {
        const textarea = container.querySelector('textarea');

        if (textarea) return textarea;
      }
    } else {
      for (const container of matching) {
        const input = container.querySelector(
          'input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"])'
        );

        if (input) return input;
      }
    }

    return null;
  }

  function getModeContainer() {
    return getContainerByLabel('Izgled teksta');
  }

  function selectedMode() {
    const container = getModeContainer();

    if (!container) return 'Sva velika slova';

    const checked = container.querySelector(
      'input[type="radio"]:checked, input.tpo_buttons-input:checked'
    );

    if (checked && checked.value) {
      const value = clean(checked.value);

      if (
        value === 'Sva velika slova' ||
        value === 'Kako je upisano'
      ) {
        return value;
      }
    }

    const selectedLabel = container.querySelector(
      'label.tpo_is_checked_swatches'
    );

    if (selectedLabel) {
      const input = selectedLabel.querySelector('input');

      const value = clean(
        selectedLabel.getAttribute('data-color-name') ||
        (input && input.value) ||
        ''
      );

      if (
        value === 'Sva velika slova' ||
        value === 'Kako je upisano'
      ) {
        return value;
      }
    }

    return 'Sva velika slova';
  }

  function setFieldValue(field, value) {
    if (!field) return;
    if (field.value === value) return;

    internalChange = true;

    field.value = value;

    field.dispatchEvent(
      new Event('input', { bubbles: true })
    );

    field.dispatchEvent(
      new Event('change', { bubbles: true })
    );

    internalChange = false;
  }

  function applyMode(forcedMode) {
    const field = getTextField();

    if (!field) return;

    const mode = forcedMode || selectedMode();

    if (
      mode !== 'Sva velika slova' &&
      mode !== 'Kako je upisano'
    ) {
      return;
    }

    if (mode === 'Sva velika slova') {
      /*
        Čuvamo verziju sa velikim/malim slovima
        pre nego što je pretvorimo u velika.
      */
      if (
        lastMode !== 'Sva velika slova' ||
        !field.dataset.raccoonOriginalCase
      ) {
        field.dataset.raccoonOriginalCase =
          field.value || '';
      }

      setFieldValue(
        field,
        String(field.value || '').toLocaleUpperCase('sr')
      );

      lastMode = mode;
      return;
    }

    /*
      Ako se kupac vrati na "Kako je upisano",
      vraćamo poslednju sačuvanu verziju sa originalnim
      velikim/malim slovima.
    */
    if (field.dataset.raccoonOriginalCase !== undefined) {
      setFieldValue(
        field,
        field.dataset.raccoonOriginalCase
      );
    }

    lastMode = mode;
  }

  /*
    Dok kupac kuca:
    - "Kako je upisano" čuva upravo taj oblik teksta
    - "Sva velika slova" odmah pretvara unos u velika
  */
  document.addEventListener(
    'input',
    function (event) {
      if (internalChange) return;

      const field = getTextField();

      if (!field || event.target !== field) return;

      const mode = selectedMode();

      if (mode === 'Kako je upisano') {
        field.dataset.raccoonOriginalCase =
          field.value || '';

        lastMode = mode;
        return;
      }

      if (mode === 'Sva velika slova') {
        /*
          Čuvamo ono što je kupac upravo uneo pre
          pretvaranja u velika slova.
        */
        field.dataset.raccoonOriginalCase =
          field.value || '';

        const upper = String(
          field.value || ''
        ).toLocaleUpperCase('sr');

        setFieldValue(field, upper);

        lastMode = mode;
      }
    },
    true
  );

  function valueFromLabel(label) {
    if (!label) return '';

    const input = label.querySelector(
      'input[type="radio"], input.tpo_buttons-input'
    );

    return clean(
      label.getAttribute('data-color-name') ||
      (input && input.value) ||
      ''
    );
  }

  /*
    Menjanje opcije Izgled teksta.
  */
  document.addEventListener(
    'pointerdown',
    function (event) {
      const container = getModeContainer();

      if (!container) return;

      const label = event.target.closest(
        '.tpo_buttons-wrapper label'
      );

      if (!label || !container.contains(label)) return;

      const value = valueFromLabel(label);

      if (
        value !== 'Sva velika slova' &&
        value !== 'Kako je upisano'
      ) {
        return;
      }

      /*
        Pre prelaska na velika slova sačuvaj trenutno
        stanje teksta baš kako je upisano.
      */
      const field = getTextField();

      if (
        field &&
        value === 'Sva velika slova' &&
        selectedMode() !== 'Sva velika slova'
      ) {
        field.dataset.raccoonOriginalCase =
          field.value || '';
      }

      requestAnimationFrame(function () {
        applyMode(value);
      });

      setTimeout(function () {
        applyMode(value);
      }, 80);
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      const container = getModeContainer();

      if (!container || !container.contains(event.target)) {
        return;
      }

      if (
        event.target.matches(
          'input[type="radio"], input.tpo_buttons-input'
        )
      ) {
        applyMode(event.target.value);
      }
    },
    true
  );

  function initialize() {
    const field = getTextField();

    if (field) {
      field.dataset.raccoonOriginalCase =
        field.value || '';
    }

    lastMode = selectedMode();
    applyMode(lastMode);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initialize();
        setTimeout(initialize, 400);
        setTimeout(initialize, 1000);
      }
    );
  } else {
    initialize();
    setTimeout(initialize, 400);
    setTimeout(initialize, 1000);
  }

})();



/* =========================================
   PREZIME | NATPIS – JEDAN / DVA REDA
   Shopify metafield: custom.raspored_natpisa

   - "Dva reda"  -> koristi Text area
   - prazno / "Jedan red" -> koristi običan Text box
   - Text area dozvoljava najviše 2 reda
   ========================================= */

(function () {
  'use strict';

  const CONTAINER_SELECTOR =
    '.tpo-option-container, .tpo_option-container';

  let scheduled = false;
  let internalChange = false;

  function clean(value) {
    return String(value || '')
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isTwoLineProduct() {
    const data =
      document.getElementById('raccoon-product-data');

    if (!data) return false;

    return String(
      data.dataset.raccoonTextLayout || ''
    ).trim() === 'Dva reda';
  }

  function getLabelText(container) {
    if (!container) return '';

    const label = container.querySelector(
      '.tpo-option-label-container .form__label, ' +
      '.tpo_option-label-container .form__label, ' +
      '.form__label'
    );

    return label
      ? clean(label.textContent).replace(/\s*\*$/, '')
      : '';
  }

  function getNameContainers() {
    return Array.from(
      document.querySelectorAll(CONTAINER_SELECTOR)
    ).filter(function (container) {
      return getLabelText(container) === 'Prezime | Natpis';
    });
  }

  function getFields(container) {
    if (!container) return [];

    return Array.from(
      container.querySelectorAll(
        'input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]), textarea'
      )
    );
  }

  function rememberFieldState(field) {
    if (!field) return;

    if (
      field.dataset.raccoonOriginalName === undefined
    ) {
      field.dataset.raccoonOriginalName =
        field.getAttribute('name') || '';
    }

    if (
      field.dataset.raccoonOriginalRequired === undefined
    ) {
      field.dataset.raccoonOriginalRequired =
        field.required ? '1' : '0';
    }
  }

  function activateField(field) {
    if (!field) return;

    rememberFieldState(field);

    field.disabled = false;
    delete field.dataset.raccoonInactiveTextField;

    const originalName =
      field.dataset.raccoonOriginalName || '';

    if (originalName) {
      field.setAttribute('name', originalName);
    }

    if (
      field.dataset.raccoonOriginalRequired === '1'
    ) {
      field.required = true;
      field.setAttribute('aria-required', 'true');
    }
  }

  function deactivateField(field) {
    if (!field) return;

    rememberFieldState(field);

    field.dataset.raccoonInactiveTextField = '1';
    field.disabled = true;
    field.required = false;

    field.removeAttribute('name');
    field.removeAttribute('aria-required');
  }

  function clearContainerError(container) {
    if (!container) return;

    container.removeAttribute('data-error');

    container
      .querySelectorAll('[data-error]')
      .forEach(function (element) {
        element.removeAttribute('data-error');
      });

    container
      .querySelectorAll(
        '.tpo_error-message, .tpo-error-message'
      )
      .forEach(function (message) {
        message.textContent = '';
        message.classList.remove('active');
      });
  }

  function setContainerActive(container, active) {
    if (!container) return;

    const fields = getFields(container);

    if (active) {
      container.style.removeProperty('display');

      fields.forEach(function (field) {
        activateField(field);
      });
    } else {
      container.style.setProperty(
        'display',
        'none',
        'important'
      );

      fields.forEach(function (field) {
        deactivateField(field);
      });

      clearContainerError(container);
    }
  }

  function limitTextareaToTwoLines(textarea) {
    if (
      !(textarea instanceof HTMLTextAreaElement)
    ) {
      return;
    }

    let value = String(textarea.value || '')
      .replace(/\r\n?/g, '\n');

    const parts = value.split('\n');

    if (parts.length <= 2) return;

    /*
      Ako je nalepljeno više od dva reda,
      višak ne brišemo nego ga spajamo u drugi red.
    */
    value =
      parts[0] +
      '\n' +
      parts.slice(1).join(' ');

    internalChange = true;

    const cursor =
      typeof textarea.selectionStart === 'number'
        ? textarea.selectionStart
        : value.length;

    textarea.value = value;

    try {
      textarea.setSelectionRange(
        Math.min(cursor, value.length),
        Math.min(cursor, value.length)
      );
    } catch (error) {}

    textarea.dispatchEvent(
      new Event('input', { bubbles: true })
    );

    textarea.dispatchEvent(
      new Event('change', { bubbles: true })
    );

    internalChange = false;
  }

  function updateTwoLineTextareaHeight(textarea) {
    if (!(textarea instanceof HTMLTextAreaElement)) return;

    const hasSecondLine =
      String(textarea.value || '').includes('\n');

    /*
      Sprečavamo Easify/browser da textarea prikaže kao
      klasično veliko višeredno polje ili da doda scrollbar.
    */
    textarea.setAttribute('rows', '1');

    textarea.style.setProperty(
      'resize',
      'none',
      'important'
    );

    textarea.style.setProperty(
      'overflow',
      'hidden',
      'important'
    );

    textarea.style.setProperty(
      'overflow-y',
      'hidden',
      'important'
    );

    /*
      48px = ista početna visina kao polje Broj.
      Kada postoji jedan Enter, dodajemo samo jednu liniju.
    */
    const height =
      hasSecondLine ? '68px' : '48px';

    textarea.style.setProperty(
      'height',
      height,
      'important'
    );

    textarea.style.setProperty(
      'min-height',
      height,
      'important'
    );
  }

  function updateNameFields() {
    const containers = getNameContainers();

    if (!containers.length) return;

    const twoLines = isTwoLineProduct();

    let textareaContainer = null;
    let inputContainer = null;

    containers.forEach(function (container) {
      if (
        !textareaContainer &&
        container.querySelector('textarea')
      ) {
        textareaContainer = container;
      }

      if (
        !inputContainer &&
        container.querySelector(
          'input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"])'
        )
      ) {
        inputContainer = container;
      }
    });

    /*
      Važno:
      Easify ponekad pri prvom učitavanju napravi samo aktivno polje,
      a drugo polje ubaci tek kasnije. Zato više NE čekamo da oba
      kontejnera postoje.

      Dva reda:
      - čim se textarea pojavi, odmah je podešavamo na 48px
      - ako se stari input pojavi, sakrivamo ga

      Jedan red:
      - čim se input pojavi, ostavljamo njega
      - ako se textarea pojavi, sakrivamo je
    */
    if (twoLines) {
      if (textareaContainer) {
        setContainerActive(
          textareaContainer,
          true
        );

        textareaContainer.classList.add(
          'raccoon-two-line-name-container'
        );

        const textarea =
          textareaContainer.querySelector('textarea');

        limitTextareaToTwoLines(textarea);
        updateTwoLineTextareaHeight(textarea);
      }

      if (inputContainer) {
        setContainerActive(
          inputContainer,
          false
        );
      }

      return;
    }

    if (inputContainer) {
      setContainerActive(
        inputContainer,
        true
      );
    }

    if (textareaContainer) {
      textareaContainer.classList.remove(
        'raccoon-two-line-name-container'
      );

      setContainerActive(
        textareaContainer,
        false
      );
    }
  }

  /*
    Drugi Enter nije dozvoljen.
  */
  document.addEventListener(
    'keydown',
    function (event) {
      if (
        event.key !== 'Enter' ||
        !isTwoLineProduct()
      ) {
        return;
      }

      const textarea = event.target;

      if (
        !(textarea instanceof HTMLTextAreaElement)
      ) {
        return;
      }

      const container =
        textarea.closest(CONTAINER_SELECTOR);

      if (
        !container ||
        getLabelText(container) !== 'Prezime | Natpis'
      ) {
        return;
      }

      const value =
        String(textarea.value || '');

      const start =
        typeof textarea.selectionStart === 'number'
          ? textarea.selectionStart
          : value.length;

      const end =
        typeof textarea.selectionEnd === 'number'
          ? textarea.selectionEnd
          : start;

      const selectedText =
        value.slice(start, end);

      /*
        Ako selekcija već sadrži postojeći Enter,
        dozvoljavamo zamenu. U suprotnom drugi Enter blokiramo.
      */
      const existingNewline =
        value.includes('\n');

      const replacingNewline =
        selectedText.includes('\n');

      if (
        existingNewline &&
        !replacingNewline
      ) {
        event.preventDefault();
        return;
      }

      setTimeout(function () {
        updateTwoLineTextareaHeight(textarea);
      }, 0);
    },
    true
  );

  /*
    Za paste i mobilne tastature dodatno čistimo višak redova.
  */
  document.addEventListener(
    'input',
    function (event) {
      if (internalChange) return;
      if (!isTwoLineProduct()) return;

      const textarea = event.target;

      if (
        !(textarea instanceof HTMLTextAreaElement)
      ) {
        return;
      }

      const container =
        textarea.closest(CONTAINER_SELECTOR);

      if (
        !container ||
        getLabelText(container) !== 'Prezime | Natpis'
      ) {
        return;
      }

      limitTextareaToTwoLines(textarea);
      updateTwoLineTextareaHeight(textarea);
    },
    true
  );

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      updateNameFields();
    });
  }

  const observer =
    new MutationObserver(function () {
      scheduleUpdate();
    });

  function initialize() {
    updateNameFields();

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(updateNameFields, 300);
    setTimeout(updateNameFields, 800);
    setTimeout(updateNameFields, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }

})();



/* =========================================
   PLOČICA ZA POŠTANSKO SANDUČE
   Easify checkbox -> Shopify varijanta Ne / Da

   Kupac vidi samo Easify checkbox.
   Shopify opcija "Pločica za sanduče" ostaje skrivena,
   ali u pozadini menja varijantu i cenu.
   ========================================= */

(function () {
  'use strict';

  const EASIFY_CONTAINER_SELECTOR =
    '.tpo-option-container, .tpo_option-container';

  const EASIFY_LABEL =
    'Pločica za poštansko sanduče';

  const SHOPIFY_OPTION_LABEL =
    'Pločica za sanduče';

  let desiredValue = null;
  let scheduled = false;
  let internalChange = false;

  /*
    Pamti osnovne cene kartica za dimenzije (varijanta "Ne").
    Tako checkbox može da promeni UKUPNU cenu proizvoda,
    a cene ispisane u karticama dimenzija ostaju iste.
  */
  const baseDimensionPrices = new Map();

  function clean(value) {
    return String(value || '')
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* -----------------------------------------
     Easify checkbox
     ----------------------------------------- */

  function getEasifyContainer() {
    const containers =
      document.querySelectorAll(
        EASIFY_CONTAINER_SELECTOR
      );

    for (const container of containers) {
      const label = container.querySelector(
        '.tpo-option-label-container .form__label, ' +
        '.tpo_option-label-container .form__label, ' +
        '.form__label'
      );

      if (
        label &&
        clean(label.textContent) === EASIFY_LABEL
      ) {
        return container;
      }
    }

    return null;
  }

  function addMailboxStyles() {
    if (
      document.getElementById(
        'raccoon-mailbox-checkbox-style'
      )
    ) {
      return;
    }

    const style =
      document.createElement('style');

    style.id =
      'raccoon-mailbox-checkbox-style';

    style.textContent = `
      .raccoon-mailbox-option
      .tpo-option-label-container,
      .raccoon-mailbox-option
      .tpo_option-label-container {
        display: flex !important;
        align-items: center !important;
        justify-content: space-between !important;
        width: 100% !important;
      }

      .raccoon-mailbox-selected-value {
        margin-left: auto !important;
        text-align: right !important;
        color: #777777 !important;
        font-weight: 600 !important;
        font-size: 16px !important;
        line-height: 1.3 !important;
        white-space: nowrap !important;
      }

      /*
        Easify checkbox – neizabrano
      */
      .raccoon-mailbox-option
      input[type="checkbox"] {
        width: 20px !important;
        height: 20px !important;
        min-width: 20px !important;

        appearance: none !important;
        -webkit-appearance: none !important;

        border: 2px solid #777777 !important;
        border-radius: 5px !important;

        background: #ffffff !important;

        cursor: pointer !important;
        position: relative !important;

        transition:
          border-color .2s ease,
          background-color .2s ease !important;
      }

      /*
        Hover – tirkizni okvir
      */
      .raccoon-mailbox-option
      input[type="checkbox"]:hover {
        border-color: #1fa1ae !important;
      }

      /*
        Izabrano – tamno siva pozadina + tirkizni okvir
      */
      .raccoon-mailbox-option
      input[type="checkbox"]:checked {
        border-color: #1fa1ae !important;
        background: #292929 !important;
      }

      /*
        Bela kvačica
      */
      .raccoon-mailbox-option
      input[type="checkbox"]:checked::after {
        content: "" !important;

        position: absolute !important;
        left: 5px !important;
        top: 1px !important;

        width: 5px !important;
        height: 10px !important;

        border: solid #ffffff !important;
        border-width: 0 2px 2px 0 !important;

        transform: rotate(45deg) !important;
      }
    `;

    document.head.appendChild(style);
  }

  function updateMailboxSelectedValue() {
    const container =
      getEasifyContainer();

    if (!container) return;

    container.classList.add(
      'raccoon-mailbox-option'
    );

    const labelContainer =
      container.querySelector(
        '.tpo-option-label-container, ' +
        '.tpo_option-label-container'
      );

    if (!labelContainer) return;

    let selectedSpan =
      labelContainer.querySelector(
        '.raccoon-mailbox-selected-value'
      );

    if (!selectedSpan) {
      selectedSpan =
        document.createElement('span');

      selectedSpan.className =
        'raccoon-mailbox-selected-value';

      labelContainer.appendChild(
        selectedSpan
      );
    }

    const checkbox =
      getEasifyCheckbox();

    selectedSpan.textContent =
      checkbox && checkbox.checked
        ? 'Da'
        : '';
  }

  function getEasifyCheckbox() {
    const container = getEasifyContainer();

    if (!container) return null;

    return container.querySelector(
      'input[type="checkbox"]'
    );
  }

  /*
    U korpi/porudžbini želimo da Easify šalje samo:
    Pločica za poštansko sanduče: Da
    umesto celog teksta opcije.
  */
  function syncMailboxCartProperty() {
    const container = getEasifyContainer();
    const checkbox = getEasifyCheckbox();

    if (!container || !checkbox) return;

    const hidden =
      container.querySelector(
        'input[type="hidden"][name="properties[Pločica za poštansko sanduče]"]'
      ) ||
      document.querySelector(
        'input[type="hidden"][name="properties[Pločica za poštansko sanduče]"]'
      );

    if (!hidden) return;

    if (checkbox.checked) {
      hidden.value = 'Da';
    } else {
      hidden.value = '';
    }
  }

  function readDesiredValue() {
    const checkbox = getEasifyCheckbox();

    if (!checkbox) return null;

    return checkbox.checked ? 'Da' : 'Ne';
  }

  /* -----------------------------------------
     Shopify opcija Ne / Da
     ----------------------------------------- */

  function hasMailboxChoices(element) {
    if (!element) return false;

    const radios =
      element.querySelectorAll(
        'input[type="radio"]'
      );

    let hasNe = false;
    let hasDa = false;

    radios.forEach(function (input) {
      const value = clean(input.value);

      if (value === 'Ne') hasNe = true;
      if (value === 'Da') hasDa = true;
    });

    if (hasNe && hasDa) return true;

    const selects =
      element.querySelectorAll('select');

    for (const select of selects) {
      const values =
        Array.from(select.options).map(function (option) {
          return clean(option.value || option.textContent);
        });

      if (
        values.includes('Ne') &&
        values.includes('Da')
      ) {
        return true;
      }
    }

    return false;
  }

  function getShopifyOptionContainer() {
    /*
      Tražimo baš naslov "Pločica za sanduče",
      a zatim najbližeg roditelja koji sadrži Ne i Da.
      Ne oslanjamo se na konkretnu Horizon klasu,
      pa je kod otporniji na promene teme.
    */
    const candidates =
      document.querySelectorAll(
        'legend, .form__label, label, p, span, div'
      );

    for (const candidate of candidates) {
      if (
        clean(candidate.textContent) !==
        SHOPIFY_OPTION_LABEL
      ) {
        continue;
      }

      let parent = candidate.parentElement;
      let depth = 0;

      while (parent && depth < 7) {
        if (hasMailboxChoices(parent)) {
          return parent;
        }

        parent = parent.parentElement;
        depth += 1;
      }
    }

    /*
      Rezervna varijanta:
      pronađi Ne/Da radio dugmad koja dele isti kontejner.
    */
    const radios =
      Array.from(
        document.querySelectorAll(
          'input[type="radio"]'
        )
      );

    const neInput =
      radios.find(function (input) {
        return clean(input.value) === 'Ne';
      });

    const daInput =
      radios.find(function (input) {
        return clean(input.value) === 'Da';
      });

    if (neInput && daInput) {
      let parent = neInput.parentElement;
      let depth = 0;

      while (parent && depth < 7) {
        if (
          parent.contains(daInput) &&
          hasMailboxChoices(parent)
        ) {
          return parent;
        }

        parent = parent.parentElement;
        depth += 1;
      }
    }

    return null;
  }

  function hideShopifyOption() {
    const container =
      getShopifyOptionContainer();

    if (!container) return null;

    container.style.setProperty(
      'display',
      'none',
      'important'
    );

    container.setAttribute(
      'data-raccoon-mailbox-option',
      'hidden'
    );

    return container;
  }

  function selectShopifyValue(value) {
    const container =
      getShopifyOptionContainer();

    if (!container) return false;

    /* Radio / button varijanta */
    const radios =
      Array.from(
        container.querySelectorAll(
          'input[type="radio"]'
        )
      );

    const targetRadio =
      radios.find(function (input) {
        return clean(input.value) === value;
      });

    if (targetRadio) {
      if (!targetRadio.checked) {
        internalChange = true;

        /*
          .click() je važan jer Horizon preko njega
          pokreće kompletnu promenu varijante, cene i ID-a.
        */
        targetRadio.click();

        internalChange = false;
      }

      return true;
    }

    /* Select varijanta */
    const selects =
      container.querySelectorAll('select');

    for (const select of selects) {
      const option =
        Array.from(select.options).find(
          function (item) {
            return clean(
              item.value || item.textContent
            ) === value;
          }
        );

      if (!option) continue;

      if (select.value !== option.value) {
        internalChange = true;

        select.value = option.value;

        select.dispatchEvent(
          new Event(
            'change',
            { bubbles: true }
          )
        );

        internalChange = false;
      }

      return true;
    }

    return false;
  }

  function rememberBaseDimensionPrices(force) {
    /*
      Osnovne cene pamtimo SAMO kada je Shopify opcija
      za sanduče na "Ne".

      force=true koristimo nakon što je Horizon završio
      prelazak na "Ne", da prepišemo eventualno pogrešno
      zapamćene cene sa doplatom.
    */
    if (desiredValue === 'Da') return;

    document
      .querySelectorAll('.dimension-card')
      .forEach(function (card) {
        const input = card.querySelector(
          '.dimension-card__input'
        );

        const price = card.querySelector(
          '.dimension-card__price'
        );

        if (!input || !price) return;

        const value = clean(input.value);

        if (
          !value ||
          value === 'Nestandardna dimenzija'
        ) {
          return;
        }

        if (
          force ||
          !baseDimensionPrices.has(value)
        ) {
          baseDimensionPrices.set(
            value,
            price.textContent.trim()
          );
        }
      });
  }

  function restoreBaseDimensionPrices() {
    document
      .querySelectorAll('.dimension-card')
      .forEach(function (card) {
        const input = card.querySelector(
          '.dimension-card__input'
        );

        const price = card.querySelector(
          '.dimension-card__price'
        );

        if (!input || !price) return;

        const value = clean(input.value);

        if (
          !value ||
          value === 'Nestandardna dimenzija'
        ) {
          return;
        }

        const basePrice =
          baseDimensionPrices.get(value);

        if (
          basePrice &&
          price.textContent.trim() !== basePrice
        ) {
          price.textContent = basePrice;
        }
      });
  }

  function syncMailboxVariant() {
    addMailboxStyles();
    updateMailboxSelectedValue();
    syncMailboxCartProperty();

    const checkbox =
      getEasifyCheckbox();

    if (!checkbox) return;

    if (desiredValue === null) {
      desiredValue =
        checkbox.checked ? 'Da' : 'Ne';
    }

    selectShopifyValue(desiredValue);
    hideShopifyOption();

    if (desiredValue === 'Ne') {
      /*
        Kada je sanduče ISKLJUČENO, Horizon treba prvo
        da prikaže osnovne cene. Tek onda ih pamtimo.
        Ne vraćamo ništa ručno dok je "Ne".
      */
      setTimeout(function () {
        rememberBaseDimensionPrices(true);
      }, 80);

      setTimeout(function () {
        rememberBaseDimensionPrices(true);
      }, 220);

      setTimeout(function () {
        rememberBaseDimensionPrices(true);
      }, 500);

      return;
    }

    /*
      Kada je sanduče UKLJUČENO, ukupna cena gore ostaje
      uvećana preko Shopify varijante, ali kartice dimenzija
      vraćamo na zapamćene osnovne cene.
    */
    restoreBaseDimensionPrices();

    setTimeout(
      restoreBaseDimensionPrices,
      80
    );

    setTimeout(
      restoreBaseDimensionPrices,
      220
    );

    setTimeout(
      restoreBaseDimensionPrices,
      500
    );
  }

  function scheduleSync() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      syncMailboxVariant();
    });
  }

  /* -----------------------------------------
     Checkbox -> Ne / Da
     ----------------------------------------- */

  document.addEventListener(
    'change',
    function (event) {
      const checkbox =
        getEasifyCheckbox();

      if (
        !checkbox ||
        event.target !== checkbox
      ) {
        return;
      }

      desiredValue =
        checkbox.checked ? 'Da' : 'Ne';

      updateMailboxSelectedValue();
      syncMailboxCartProperty();
      syncMailboxVariant();

      /*
        Rezervne provere dok Horizon završi
        promenu varijante i cene.
      */
      setTimeout(syncMailboxVariant, 80);
      setTimeout(syncMailboxVariant, 250);
    },
    true
  );

  /*
    Rezervna provera neposredno pre slanja proizvoda u korpu.
  */
  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;

      if (
        form &&
        form.matches &&
        form.matches('form[action*="/cart/add"]')
      ) {
        syncMailboxCartProperty();
      }
    },
    true
  );

  /* -----------------------------------------
     Promena dimenzije:
     zadrži trenutno stanje checkboxa
     ----------------------------------------- */

  document.addEventListener(
    'pointerdown',
    function (event) {
      const dimension =
        event.target.closest(
          '.dimension-card'
        );

      if (!dimension) return;

      if (desiredValue === null) {
        desiredValue =
          readDesiredValue() || 'Ne';
      }

      setTimeout(syncMailboxVariant, 0);
      setTimeout(syncMailboxVariant, 100);
      setTimeout(syncMailboxVariant, 300);
      setTimeout(syncMailboxVariant, 600);
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      if (internalChange) return;

      if (
        !event.target.matches(
          '.dimension-card__input'
        )
      ) {
        return;
      }

      if (desiredValue === null) {
        desiredValue =
          readDesiredValue() || 'Ne';
      }

      setTimeout(syncMailboxVariant, 0);
      setTimeout(syncMailboxVariant, 100);
      setTimeout(syncMailboxVariant, 300);
      setTimeout(syncMailboxVariant, 600);
    },
    true
  );

  /* -----------------------------------------
     Easify / Horizon mogu naknadno menjati DOM
     ----------------------------------------- */

  const observer =
    new MutationObserver(function () {
      scheduleSync();
    });

  function initialize() {
    addMailboxStyles();
    updateMailboxSelectedValue();

    desiredValue =
      readDesiredValue() || 'Ne';

    /*
      Ne pamtimo cene pre prve Shopify sinhronizacije,
      jer Horizon tada može još uvek da prikazuje "Da" cene.
      syncMailboxVariant() će prvo prebaciti na "Ne",
      pa tek onda zapamtiti osnovne cene.
    */
    syncMailboxVariant();

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(syncMailboxVariant, 200);
    setTimeout(syncMailboxVariant, 500);
    setTimeout(syncMailboxVariant, 1000);
    setTimeout(syncMailboxVariant, 1800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }

})();



/* =========================================
   RASPORED NATPISA – INFO U KORPI/PORUDŽBINI
   Samo za proizvode sa metafieldom "Dva reda"

   - bez Entera -> Jedan red
   - sa Enterom -> Dva reda
   ========================================= */

(function () {
  'use strict';

  const CONTAINER_SELECTOR =
    '.tpo-option-container, .tpo_option-container';

  const PROPERTY_NAME =
    'Raspored natpisa';

  function clean(value) {
    return String(value || '')
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isTwoLineProduct() {
    const data =
      document.getElementById(
        'raccoon-product-data'
      );

    if (!data) return false;

    return String(
      data.dataset.raccoonTextLayout || ''
    ).trim() === 'Dva reda';
  }

  function getNameField() {
    const containers =
      document.querySelectorAll(
        CONTAINER_SELECTOR
      );

    for (const container of containers) {
      const label = container.querySelector(
        '.tpo-option-label-container .form__label, ' +
        '.tpo_option-label-container .form__label, ' +
        '.form__label'
      );

      const labelText = label
        ? clean(label.textContent).replace(/\s*\*$/, '')
        : '';

      if (labelText !== 'Prezime | Natpis') {
        continue;
      }

      const textarea =
        container.querySelector(
          'textarea:not([disabled])'
        );

      if (textarea) return textarea;

      const input =
        container.querySelector(
          'input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]):not([disabled])'
        );

      if (input) return input;
    }

    return null;
  }

  function getProductForm() {
    const field = getNameField();

    if (field && field.form) {
      return field.form;
    }

    return document.querySelector(
      'form[action*="/cart/add"]'
    );
  }

  function getOrCreatePropertyInput() {
    if (!isTwoLineProduct()) {
      return null;
    }

    const form = getProductForm();

    if (!form) return null;

    let input =
      form.querySelector(
        'input[data-raccoon-text-layout-property="1"]'
      );

    if (!input) {
      input =
        document.createElement('input');

      input.type = 'hidden';
      input.name =
        'properties[' + PROPERTY_NAME + ']';

      input.dataset.raccoonTextLayoutProperty =
        '1';

      form.appendChild(input);
    }

    return input;
  }

  function updateProperty() {
    if (!isTwoLineProduct()) return;

    const field = getNameField();
    const property =
      getOrCreatePropertyInput();

    if (!field || !property) return;

    const hasEnter =
      String(field.value || '')
        .replace(/\r\n?/g, '\n')
        .includes('\n');

    property.value =
      hasEnter ? 'Dva reda' : 'Jedan red';
  }

  document.addEventListener(
    'input',
    function (event) {
      const field = getNameField();

      if (
        field &&
        event.target === field
      ) {
        updateProperty();
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      const field = getNameField();

      if (
        field &&
        event.target === field
      ) {
        updateProperty();
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      const form = getProductForm();

      if (
        form &&
        event.target === form
      ) {
        updateProperty();
      }
    },
    true
  );

  function initialize() {
    updateProperty();

    setTimeout(updateProperty, 300);
    setTimeout(updateProperty, 800);
    setTimeout(updateProperty, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }

})();